<template>
  <div class="participant_content participant-bg" @click="hideModal()">
    <div class="modal fade" v-if="eligibilityScreenQuestionsAnsOfParticipnt" id="eligibilityScreenQuestionsAns" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-w-h-style modal-content p-0 m-0">
          <div class="modal-header header-rectangle border-none m-0 p-0">
            <p class="agreement-accepted-style m-0 mr-45 mt-14 p-0">
              Agreement Accepted on
              <span v-if="agreementAcceptedDate">{{ agreementAcceptedDate }} at {{ agreementAcceptedTime }} UTC </span>
            </p>
            <select class="lang-slection-style" name="language" v-model="selectedLang">
              <option :value="undefined" selected="selected" disabled>
                Select
              </option>
              <option>{{ getLanguageText(displayLanguage) }}</option>
            </select>
            <button type="button" class="close-btn" data-dismiss="modal">
              x
            </button>
          </div>
          <div class="modal-body m-4 p-0">
            <div class="eligibility-heading-style">Eligibility Responses</div>
            <div class="row margin-style-2 p-0">
              <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8 pl-0 mb-8 mt-8 question-answer-style-heading">
                QUESTION
              </div>
              <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-0 mb-8 mt-8 question-answer-style-heading">
                ANSWER
              </div>
            </div>
            <div v-if="isLoading === true" class="loading-style">
              <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
            </div>
            <div v-if="isLoading === false" class="question-wrapper">
              <div class="row margin-style-1 p-0 gray-color" v-for="(queAndAns, index) in eligibilityScreenQuestionsAnsOfParticipnt" :key="index">
                <div class="d-flex col-xs-8 col-sm-8 col-md-8 col-lg-8 pl-0">
                  <span class="pr-14">{{ index + 1 }}.</span>
                  <span v-html="queAndAns.question"></span>
                </div>
                <div v-if="queAndAns.question_type === 'MultiChoiceQuestion'" v-html="queAndAns.answer_text" class="col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-0"></div>
                <div v-if="queAndAns.question_type === 'BooleanQuestion'" class="col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-0">
                  {{ queAndAns.answer_text }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="changeScreeningStatus" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content p-20">
          <div class="modal-header border-none m-4 p-0">
            <p class="change-screening-status m-0 p-0">
              Change participant screening status
            </p>
          </div>
          <div class="modal-body m-4 p-0">
            <div class="rectangle">
              <div class="field-wrapper">
                <p class="participant-ID">Participant ID</p>
                <p class="participant-ID-field" v-if="selectedParticipantForChangeStatusValue.userDefinedParticipantId">
                  {{ selectedParticipantForChangeStatusValue.userDefinedParticipantId }}
                </p>
              </div>
              <div class="field-wrapper">
                <p class="thread-ID">Thread ID</p>
                <p class="thread-ID-field" v-if="selectedParticipantForChangeStatusValue.id">
                  {{ selectedParticipantForChangeStatusValue.id }}
                </p>
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-center mt-8 mb-6 m-4 p-0">
            <button type="button" class="cancel-modal-but" data-dismiss="modal" v-on:click="resetSelectedParticipant">
              <span>Cancel</span>
            </button>
            <button type="button" class="screening-failed-but" data-dismiss="modal" v-on:click="screeningFailed(selectedParticipantForChangeStatusValue.id, selectedParticipantForChangeStatusValue.email, selectedParticipantForChangeStatusValue.siteId)">
              <span class="screening-failed-span">Screening failed</span>
            </button>
            <button type="button" class="screening-passed-but" data-toggle="modal" data-target="#inviteParticipantNow" data-dismiss="modal" v-on:click="screeningPassed(selectedParticipantForChangeStatusValue.id, selectedParticipantForChangeStatusValue.email, selectedParticipantForChangeStatusValue.siteId)">
              <span class="screening-passed-span">Screening passed</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!---Modal screen failure----->
    <div class="modal fade " v-if="failureReasons" id="screenFailureResons" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header border-none m-0 p-0">
            <p class="reasons-modal-title m-0 p-3">
              Reasons for Screen Failure
            </p>
            <button type="button" class="close" @click="closeScreenFailureModal">
              &times;
            </button>
          </div>
          <div class="modal-body m-4 p-0">
            <div class="screen-failure">
              <div class="failure-reasons" v-if="failureReasons">
                <ul>
                  <li v-for="(reasons, index) in failureReasons.reasons" :key="index">
                    {{ reasons }}
                  </li>
                  <li v-if="failureReasons && failureReasons.other">
                    Other
                    <p class="other-failure-reasons">
                      {{ failureReasons.other }}
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="inviteParticipantNow" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content p-20">
          <div class="modal-header border-none m-4 p-0">
            <p class="change-screening-status m-0 p-0">
              Change participant screening status
            </p>
          </div>
          <div class="modal-body m-4 p-0">
            <div class="rectangle">
              <div class="field-wrapper">
                <p class="participant-ID">Participant ID</p>
                <p class="participant-ID-field" v-if="selectedParticipantForChangeStatusValue.userDefinedParticipantId">
                  {{ selectedParticipantForChangeStatusValue.userDefinedParticipantId }}
                </p>
              </div>
              <div class="field-wrapper">
                <p class="thread-ID">Thread ID</p>
                <p class="thread-ID-field" v-if="selectedParticipantForChangeStatusValue.id">
                  {{ selectedParticipantForChangeStatusValue.id }}
                </p>
              </div>
            </div>
          </div>
          <div class="row invite-que-style m-4 p-0">
            <div class="col text-center font-weight-bold">
              Participant has passed screening
            </div>
            <div class="col text-center">Do you want to send as invite ?</div>
          </div>
          <div class="modal-footer justify-content-center m-4 p-0">
            <button type="button" class="cancel-modal-but" data-dismiss="modal" v-on:click="resetSelectedParticipant">
              <span>Invite later</span>
            </button>
            <button type="button" class="screening-passed-but" data-dismiss="modal" v-on:click="invitedParticipant(selectedParticipantForChangeStatusValue.id, selectedParticipantForChangeStatusValue.email, selectedParticipantForChangeStatusValue.siteId)">
              <span class="screening-passed-span">Invite participant</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <nav v-if="canResearchSiteTeamAccess && composeMessageId" aria-label="breadcrumb" class="participant-breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link :to="{ name: 'study-participant-messages' }">Messages</router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link
            :to="{
              name: 'study-participant-compose-message',
              params: { composeMessageId: composeMessageId }
            }"
            >Compose Message</router-link
          >
        </li>
        <li class="breadcrumb-item current-label">
          <span>Select Participants</span>
        </li>
      </ol>
    </nav>
    <div class="content" :class="{ 'pt-30': !composeMessageId }">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0">
        <div class="participant-header">
          <div class="row">
            <div class="row pb-15 d-none">
              <span class="color_2d3752 fs-22">
                <b>
                  <span v-if="canResearchSiteTeamAccess && composeMessageId">Select Participants</span>
                  <span v-else>My Participants</span>
                </b>
              </span>
            </div>
            <div class="d-flex">
              <div class="col-sm-10 p-0">
                <div class="form-group has-feedback">
                  <input type="text" class="form-control mb-10 br-3 search-field" placeholder="Search" v-model="searchTerm" @keyup.enter="searchParticipantFilterStudies()" />
                </div>
              </div>
              <div class="col p-0">
                <button class="btn newBtn br-3 ml-5" @click="openAddModal" v-if="byInvite && canInviteParticipants() && !user.readOnly">
                  <i class="fa fa-plus" aria-hidden="true"></i>
                </button>
              </div>
            </div>

            <div class="col-xs-6 col-sm-4 col-md-4 col-lg-2 pl-0 fs-14 select_section d-none">
              <select class="form-control br-3 input-bg select_control" v-model="filterTerm" v-on:change="searchParticipantFilterStudies()">
                <option disabled value>Status</option>
                <option value>None</option>
                <option :value="getStatuses.ACTIVE">
                  {{ getStatusText({ status: getStatuses.ACTIVE }) }}
                </option>
                <option v-if="feature.length !== 0" :value="getStatuses.ACTIVEWMODIFICATION">
                  {{ getStatusText({ status: getStatuses.ACTIVEWMODIFICATION }) }}
                </option>
                <option :value="getStatuses.REGISTERED">
                  {{ getStatusText({ status: getStatuses.REGISTERED }) }}
                </option>
                <option :value="getStatuses.VERIFIED">
                  {{ getStatusText({ status: getStatuses.VERIFIED }) }}
                </option>
                <option v-if="studyData.onboardingType !== 'OpenEnrollment'" :value="getStatuses.INVITED">
                  {{ getStatusText({ status: getStatuses.INVITED }) }}
                </option>
                <option v-if="studyData.onboardingType !== 'OpenEnrollment'" :value="getStatuses.NOTINVITED">
                  {{ getStatusText({ status: getStatuses.NOTINVITED }) }}
                </option>
                <option v-if="legacyVal" :value="getStatuses.WITHDRAWSTUDY">
                  {{ getStatusText({ status: getStatuses.WITHDRAWSTUDY }) }}
                </option>
                <option v-if="legacyVal" :value="getStatuses.DISQUALIFIED">
                  {{ getStatusText({ status: getStatuses.DISQUALIFIED }) }}
                </option>
                <option v-if="!legacyVal" :value="getStatuses.DISCONTINUED">{{ getStatusText({ status: getStatuses.DISCONTINUED }) }}</option>
                <option :value="getStatuses.PRESCREENED">
                  {{ getStatusText({ status: getStatuses.PRESCREENED }) }}
                </option>
                <option :value="getStatuses.SCREENPASSED">
                  {{ getStatusText({ status: getStatuses.SCREENPASSED }) }}
                </option>
                <option :value="getStatuses.SCREENFAILED">
                  {{ getStatusText({ status: getStatuses.SCREENFAILED }) }}
                </option>
              </select>
            </div>
            <div class="col-xs-6 col-sm-4 col-md-4 col-lg-2 pl-0 fs-14 select_section d-none">
              <select class="form-control br-3 input-bg select_control" v-model="sourcefilter" v-on:change="searchParticipantFilterStudies()">
                <option disabled value>Source</option>
                <option value>None</option>
                <option :value="getSources.WEB">
                  {{ getSourceText({ source: getSources.WEB }) }}
                </option>
                <option :value="getSources.APP">
                  {{ getSourceText({ source: getSources.APP }) }}
                </option>
                <option :value="getSources.MANUAL">
                  {{ getSourceText({ source: getSources.MANUAL }) }}
                </option>
              </select>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3 pl-0 d-none">
              <div class="form-group has-feedback">
                <label for="checkWithdrawn" class="Show-Withdrawn-or-Failed-participants" v-if="legacyVal">
                  <input id="checkWithdrawn" type="checkbox" class="check-withwrawn" :checked="setWithdrawnOrFailedFilter" v-on:change="changeWithdrawnOrFailedFilter" />
                  Show Withdrawn or Failed participants
                  <span class="checkmark"></span>
                </label>
                <label for="checkWithdrawn" class="Show-Withdrawn-or-Failed-participants" v-else>
                  <input id="checkWithdrawn" type="checkbox" class="check-withwrawn" :checked="setWithdrawnOrFailedFilter" v-on:change="changeWithdrawnOrFailedFilter" />
                  Show Discontinued or Failed participants
                  <span class="checkmark"></span>
                </label>
              </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-4 col-lg-3 xs-pl-0 mob-pt15 mb-10 pr-0">
              <!-- Back to compose button section -->
              <div v-if="canResearchSiteTeamAccess && composeMessageId" class="back-to-compose text-right">
                <button :disabled="composeParticipants.length <= 0" @click="backToComposeMessage" class="btn newBtn br-3 ml-5">
                  Back to Compose Message
                </button>
              </div>
              <!-- Back to compose button section ends here -->
              <div v-else class="text-right">
                <button class="btn newBtn br-3" v-if="byInvite && participantNotInvited && canInviteParticipants() && !user.readOnly" @click="batchInvite()">
                  Invite all
                </button>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12 col-xs-12 pb-20 pl-0 pr-0">
              <div class="table-column p-10">
                <div class="row">
                  <div class="d-flex">
                    <div class="col-sm-10 col-md-9 col-lg-10 col-xs-12 p-0 lh-36 fs-17 fw-bold">
                      <span class="color_f16559">{{ totalParticipants }} &nbsp;</span>
                      <span class="color_2d3752">{{ totalParticipants !== null ? "Participants" : "Updating Participant Count" }}</span>
                      <span v-if="canResearchSiteTeamAccess && composeMessageId && composeParticipants.length" class="compose-part-sel-text">{{ composeParticipants.length }} participant(s) selected</span>
                    </div>
                    <div class="col-sm-2 col-md-3 col-lg-2 col-xs-12 p-0 show_section text-right">
                      <b-form-select v-model="selectedShowOption" :options="participantListOptions" class="input-bg select_control mb-3 fs-12" size="sm" @change="showParticipants" />
                    </div>
                  </div>
                </div>
                <div class="wrapper height-500 position-relative">
                  <div class="row">
                    <div class="col-sm-12 col-xs-12 p-0 card_wrapper" v-if="currentParticipantsList && currentParticipantsList.length > 0">
                      <div class="card" v-for="(participant, index) in currentParticipantsList" :key="index">
                        <!-- <pre>{{participant | json}}</pre> -->
                        <div class="card-horizontal">
                          <div class="card-body">
                            <div class="card-title">
                              <div class="col-sm-12 col-xs-12 p-0 d-flex justify-content-between">
                                <div class="participant_id ellipsisPID">
                                  <!-- userDefinedParticipantId -->
                                  <span v-if="participant.userDefinedParticipantId">{{ $sanitize(participant.userDefinedParticipantId) }}</span>
                                  <span v-else class="text-center"> - </span>
                                </div>
                                <div class="pr-0">
                                  <!-- participant id -->
                                  <div class="participant_id ta-e">
                                    <span v-if="(canPiAccess || canSubPIAccess || canStudyCoordinatorAccess || canHomeHealthAccess) && !participant.showMore">{{ participant.id.slice(0, 8) }}...</span>
                                    <span v-if="(canPiAccess || canSubPIAccess || canStudyCoordinatorAccess || canHomeHealthAccess) && participant.showMore">{{ participant.id }} &nbsp;</span>
                                    <a
                                      class=""
                                      @click="changeState(participant.id)"
                                      v-if="!(canPiAccess || canSubPIAccess || canStudyCoordinatorAccess || canHomeHealthAccess) && !participant.showMore"
                                      :to="{
                                        name: 'study-participant-details',
                                        params: {
                                          participantId: participant.id
                                        }
                                      }"
                                    >
                                      {{ participant.id.slice(0, 8) }}...
                                    </a>
                                    <a v-if="!participant.showMore" class="cursor_pointer table-content-color fs-12 link" @click="toggleShowMore(index)">
                                      <u>Show</u>
                                    </a>
                                    <a
                                      class=""
                                      @click="changeState(participant.id)"
                                      v-if="!(canPiAccess || canSubPIAccess || canStudyCoordinatorAccess || canHomeHealthAccess) && participant.showMore"
                                      :to="{
                                        name: 'study-participant-details',
                                        params: {
                                          participantId: participant.id
                                        }
                                      }"
                                    >
                                      {{ participant.id }} &nbsp;
                                    </a>
                                    <a v-if="participant.showMore" class="cursor_pointer table-content-color fs-12 link" @click="toggleShowMore(index)">
                                      <u>Less</u>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="card-text">
                              <div class="col-sm-12 col-xs-12 p-0 d-flex justify-content-between">
                                <div class="pl-0">
                                  <!-- email -->
                                  <div class="status ellipsis" v-if="canPiAccess || canSubPIAccess || canStudyCoordinatorAccess || canHomeHealthAccess || canSiteDataLockAccess || user.readOnly">
                                    <!-- <a
                                      class="link"
                                      @click="changeState(participant.id)"
                                      v-if="participant.email.length >= 16"
                                      >{{
                                        participant.email.slice(0, 14)
                                      }}...</a
                                    > -->
                                    <a class="link" @click="changeState(participant.id)">{{ $sanitize(participant.email) }}</a>
                                  </div>
                                </div>
                                <div class="pr-0">
                                  <!-- status -->
                                  <div
                                    class="status ta-e"
                                    v-bind:class="{
                                      color_red: participant.status === getStatuses.WITHDRAWSTUDY || participant.status === getStatuses.DISQUALIFIED || participant.status === getStatuses.WITHDRAWCONSENT,
                                      color_yellow: participant.status === getStatuses.INVITED || participant.status === getStatuses.VERIFIED,
                                      purple_color: participant.status === getStatuses.PRESCREENED
                                    }"
                                  >
                                    <span class="" v-if="participant.status !== 'ACTIVEWMODIFICATION'"
                                      >{{ getStatusText(participant) }}<span class="pl-5" v-b-popover.hover="participant.disqualifyReason" v-if="participant.status === getStatuses.DISQUALIFIED"><i class="fa fa-info-circle help_icon cursor_pointer"></i></span>
                                      <span class="pl-5" v-if="participant.status === getStatuses.SCREENFAILED && participant.hasOwnProperty('screenFailureReasons')">
                                        <img src="../../../public/static/img/participant-web-img/screen-failure.svg" data-toggle="modal" data-target="#screenFailureResons" class="screen-failure-popup-icon" v-on:click="getScreenFailureReasons(participant)" />
                                      </span>
                                    </span>
                                    <span class="pl-5" v-if="participant.status === getStatuses.DISCONTINUED">
                                      <i class="fa fa-info-circle help_icon cursor_pointer screen-failure-popup-icon" v-on:click="getDiscontinuedReasons(participant)" data-toggle="modal" data-target="#screenFailureResons"></i>
                                    </span>
                                    <span class="" v-if="participant.status === 'ACTIVEWMODIFICATION'"
                                      >Active
                                      <span class="activeModificationBlock"> <span class="modifiedText">Modified</span></span>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="img-square-wrapper">
                            <span class="card-img"
                              ><a @click="changeState(participant.id)"><i class="fa fa-angle-right fs-30"></i></a
                            ></span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-12 col-xs-12 p-0" v-if="allParticipants && allParticipants.length <= 0 && filterTerm === '' && searchTerm === null">
                      <div class="card">
                        <div class="card-horizontal">
                          <div class="card-body">
                            <div class="text-center">
                              <div class="row text-center">
                                <div class="fs-20">
                                  <b>No participants in this study yet</b>
                                </div>
                                <div v-if="canInviteParticipants() && !user.readOnly">
                                  <div v-if="byInvite" class="fs-15 line-height pb-15 pt-10">
                                    You may start inviting participants or load participants<br />
                                    now and send out invitations at a later time.
                                  </div>
                                  <button class="btn newBtn br-3 fs-15" @click="openAddModal" v-if="byInvite">
                                    Start inviting now
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-12 col-xs-12 p-0" v-if="allParticipants && allParticipants.length <= 0 && (filterTerm !== '' || searchTerm !== null)">
                      <div class="card">
                        <div class="card-horizontal">
                          <div class="card-body">
                            <div class="text-center">
                              <div class="row text-center">
                                <div class="fs-20">
                                  <b>0 participants found</b>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="img-square-wrapper">
                            <span class="card-img"><i class="fa fa-angle-right fs-35 d_margin"></i></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="pb-20 pl-15 position-absolute bottom-0" v-if="currentParticipantsList && currentParticipantsList.length">
                    <div class="row display-inline-flex">
                      <div @click="prevPage" class="arrow-icon cursor_pointer" :class="{ disabledPagination: currentPage <= 1 }">
                        <i class="fa fa-angle-left fs-23 pt-3"></i>
                      </div>
                      <div class="pagination pt-3">{{ currentPage }}</div>
                      <div class="pagination2 pt-3">of {{ totalPages }}</div>
                      <div
                        @click="nextPage"
                        class="arrow-icon pt-3 cursor_pointer"
                        :class="{
                          disabledPagination: currentPage >= totalPages
                        }"
                      >
                        <i class="fa fa-angle-right fs-23"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="import-participant-modal" class="modal modal-position fade" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <button type="button" class="close close-style" data-dismiss="modal"></button>
          <div v-if="showDefaultImport">
            <div class="modal-title pl-20 pr-20 pt-20">
              Import Participant List
            </div>
            <div class="modal-body modal-style">
              <p class="mb-80 modal-info">
                If you already have a list of participants ready, you may insert their information into our
                <a class="link-color cursor_pointer" @click="downloadTemplate()">.csv template</a>
                and upload them into this study’s participant list.
              </p>
            </div>
            <div class="form-group">
              <!-- <div class="btn btn-lg btn-block btn-info-blue br-30 file-upload file-upload-participant">
                <input type="file" class="file-input" id="file_upload" @change="onFileChange($event)">
                <span>Upload</span>
              </div>-->
              <button class="btn btn-lg btn-block btn-info-blue br-30" @click="importCSV(setImportValue)" :disabled="!setImportValue">
                Confirm
              </button>
            </div>
            <div class="footer-close-style" data-dismiss="modal" @click="clearImport()">
              Close
            </div>
          </div>
          <div v-if="showImporting">
            <h2 class="color_import text-center">Importing csv file…</h2>
            <div class="file-style">
              <i class="fa fa-file fs-40" aria-hidden="true"></i>
              <br />
              {{ fileName }}
            </div>
            <!--<vue-progress-bar class="progress-position"></vue-progress-bar>-->
            <div class="form-group">
              <p class="text-center">Uploading! Thanks for being patient.</p>
              <!--<div class="footer-close-style" @click="clearImport()" data-dismiss="modal">Cancel upload</div>-->
            </div>
          </div>
          <div v-if="afterImporting">
            <h2 class="color_import text-center" v-if="importPassed">
              Upload completed
            </h2>
            <h2 class="color_import text-center" v-if="!importPassed">
              Upload failed
            </h2>
            <div class="file-style">
              <i class="fa fa-file fs-40" aria-hidden="true"></i>
              <br />
              <span class="color_import">{{ fileName }}</span>
            </div>
            <div class="form-group">
              <button class="btn btn-lg btn-block btn-info-blue br-30" @click="uploadAnotherCSV()">
                Upload another csv file
              </button>
              <button class="btn btn-lg btn-block btn-info-blue br-30" @click="clearImport()" data-dismiss="modal">
                Done
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="invite-all-modal" class="modal modal-position fade" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content width-650 p-0">
          <div class="pr-5">
            <button type="button" class="close" data-dismiss="modal" @click="cancelInvite">
              &times;
            </button>
          </div>
          <div class="modal-body p-0">
            <div class="row download-modal">
              <h3 class="invite-text" v-if="recordsWithMissingPIDs.length == 0 && recordWithOldFormat.length == 0 && recordsWithDuplicatePIDs.length == 0">
                <b>Invite {{ notInvitedUsers.length }} participants?</b>
              </h3>
            </div>
            <div class="row download-modal pt-6 color_4a4a4a" v-if="recordsWithMissingPIDs.length == 0 && recordWithOldFormat.length == 0 && recordsWithDuplicatePIDs.length == 0">
              <span v-for="(participant, index) in notInvitedUsers" :key="index">
                {{ $sanitize(participant.email) }}
                <span v-if="index != notInvitedUsers.length - 1">,</span>
              </span>
            </div>
            <div class="row download-modal pt-6 color_4a4a4a pb-20 information" v-if="studyData && studyData.isParticipantIdRequired && recordsWithMissingPIDs.length > 0">
              <div class="pb-10 modal-heading">
                The following records were not invited because they are missing the required PID:
              </div>
              <span v-for="(participant, index) in recordsWithMissingPIDs" :key="index">
                {{ $sanitize(participant.email) }}
                <span v-if="index != recordsWithMissingPIDs.length - 1">,</span>
              </span>
            </div>
            <div class="row download-modal pt-6 color_4a4a4a pb-20 mt-20 mb-20 information" v-if="studyData && studyData.participantIdFormatConfigured && studyData.participantIdFormatConfigured.isFormattingChecked && recordWithOldFormat.length > 0">
              <div class="pb-10 modal-heading">
                The following records have PID not in the set up format:
              </div>
              <span v-for="(participant, index) in recordWithOldFormat" :key="index">
                {{ $sanitize(participant.email) }}
                <span v-if="index != recordWithOldFormat.length - 1">,</span>
              </span>
            </div>
            <div class="row download-modal pt-6 color_4a4a4a pb-20 information" v-if="studyData && !studyData.allowDuplicatePid && recordsWithDuplicatePIDs.length > 0">
              <div class="pb-10 modal-heading">
                The following records have duplicate PID:
              </div>
              <span v-for="(part, index) in recordsWithDuplicatePIDs" :key="index">
                {{ part.email }}
                <span v-if="index != recordsWithDuplicatePIDs.length - 1">,</span>
              </span>
            </div>
            <div class="row text-center pt-30 pb-20" v-if="recordsWithMissingPIDs.length == 0 && recordWithOldFormat.length == 0 && recordsWithDuplicatePIDs.length == 0">
              <button class="btn no-btn br-2 mr-4" @click="cancelInvite()">
                No
              </button>
              <button class="btn yes-btn br-2" @click="inviteAll()">Yes</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="batch-import-modal" class="modal modal-position fade" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content width-650 height-250 pl-24">
          <div class="modal-header border-none">
            <h3 class="modal-title invite-text color_2d3752">
              <b>Batch import</b>
            </h3>
            <button type="button" class="close" data-dismiss="modal" @click="closeImportModal">
              &times;
            </button>
          </div>
          <div class="modal-body pl-0 pt-6">
            <div class="row pb-90 color_4a4a4a">
              <b>You are about to import {{ fileLength }} participant(s). Please confirm to continue.</b>
            </div>
            <div class="row text-center">
              <button class="btn cancel-btn br-3 width-100 mr-10" @click="closeImportModal">
                Cancel
              </button>
              <button class="btn add-invite-btn br-3 width-100" @click="importCSV(setImportValue)">
                Import
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="uploading-modal" class="modal modal-position fade" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content height-250 pl-24">
          <div class="modal-body pt-40 text-center color_2d3752">
            <div class="row">
              <h3>
                <b>Importing participants…</b>
              </h3>
            </div>
            <div class="fs-16">Thanks for your patience</div>
            <div class="pt-20">
              <b-progress :value="value" :max="100" height="6px" variant="success"></b-progress>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="add-error-modal" class="modal modal-position fade" role="dialog">
      <div class="modal-dialog" role="document">
        <!-- Modal content-->
        <div class="modal-content width-650 p-0">
          <div class="pr-5">
            <button type="button" class="close pt-10 pr-10" data-dismiss="modal" @click="closeAddErrorModal">
              &times;
            </button>
          </div>
          <div class="modal-body p-0">
            <div class="row download-modal">
              <h3 class="invite-text">
                <b>{{ addErrorTitle }} Participant Error</b>
              </h3>
            </div>
            <div class="row color_e74c3c download-modal pt-10 pb-6" v-if="skippedParticipantsCount > 0">
              <b>{{ skippedParticipantsCount }} participant(s) failed to {{ addErrorTitle.toLowerCase() }}</b>
            </div>
            <div class="bb-e4e8eb" v-if="skippedParticipantsCount > 0"></div>
            <div class="autoScroll">
              <div class="row download-modal pt-6 color_4a4a4a" v-for="(participant, index) in skippedParticipants" :key="index">
                {{ $sanitize(participant.email) }}
              </div>
            </div>
            <div class="row download-modal pt-30 pb-20">
              <button class="btn add-invite-btn br-3" @click="exportCSV()">
                Download report
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="download-report-modal" class="modal modal-position fade" role="dialog">
      <div class="modal-dialog" role="document">
        <!-- Modal content-->
        <div class="modal-content width-650 p-0">
          <div class="pr-5">
            <button type="button" class="close pt-10 pr-10" data-dismiss="modal" @click="closeDownloadModal">
              &times;
            </button>
          </div>
          <div class="modal-body p-0">
            <div class="row download-modal">
              <h3 class="invite-text">
                <b>Batch import</b>
              </h3>
            </div>
            <div class="row color_e74c3c download-modal pt-10 pb-6" v-if="skippedParticipantsCount > 0">
              <b>{{ skippedParticipantsCount }} participant(s) failed to import</b>
            </div>
            <div class="bb-e4e8eb" v-if="skippedParticipantsCount > 0"></div>
            <div class="autoScroll">
              <div class="row download-modal pt-6 color_4a4a4a" v-for="(participant, index) in skippedParticipants" :key="index">
                {{ $sanitize(participant.email) }}
              </div>
            </div>
            <div class="row download-modal pt-30 pb-20">
              <button class="btn add-invite-btn br-3" @click="exportCSV()">
                Download report
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="add-participant-modal" class="modal fade" role="dialog" data-backdrop="static">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content pl-24">
          <div>
            <div class="modal-header border-none">
              <h3 class="modal-title invite-text">
                <b>Add participants</b>
              </h3>
              <button type="button" class="close" @click="closeModal">
                &times;
              </button>
            </div>
            <div class="modal-body pl-0 pr-0">
              <div class="row">
                <div class="btn importBtn file-upload cutom_class">
                  <input type="file" accept=".csv" class="file-input" id="file_upload" @change="onFileChange($event)" />
                  <span> <img src="static/img/batch-upload.svg" class="pl-4 pr-7 img-mr" />Batch upload </span>
                </div>
                <div class="btn importBtn lh-15 cutom_class" @click="downloadTemplate()"><img src="static/img/download.svg" class="pl-4 pr-7 img-mr" />Download batch upload template</div>
              </div>
              <div class="autoScrollList">
                <template v-if="!participant.added">
                  <div class="row pb-12" v-for="(participant, index) in participantsList" :key="participant.dynamicInputID">
                    <div class="row pt-5 fs-14 text-color font-weight-bold pb-8 pl-0 " :class="[studyData.countryList && studyData.countryList.length == 1 && (canPiAccess || canSubPIAccess || canStudyCoordinatorAccess || canHomeHealthAccess) ? 'col-lg-4 col-md-4 col-sm-12 col-xs-12' : 'col-lg-3 col-md-3 col-sm-12 col-xs-12']">
                      <div class="p-0">
                        Participant email address
                        <span data-v-68ffe67c="" aria-hidden="true" class="fa fa-asterisk asterickStyle"></span>
                      </div>
                      <input
                        type="text"
                        v-validate="'required|email'"
                        :name="`email${participant.dynamicInputID}`"
                        :class="{
                          input: true,
                          'is-danger': participant.emailError || (participant.email && errors.has(`email${participant.dynamicInputID}`)),
                          'is-success': !errors.has('email')
                        }"
                        class="form-control"
                        v-model="participant.email"
                        placeholder="Enter email address"
                        v-on:keyup="validateParticipants(index)"
                      />
                      <span v-show="participant.email && errors.has(`email${participant.dynamicInputID}`)" class="error-style">Please enter a valid email.</span>
                    </div>
                    <div v-if="!(canPiAccess || canSubPIAccess || canStudyCoordinatorAccess || canHomeHealthAccess)" class="pl-0" :class="[studyData.countryList && studyData.countryList.length == 1 ? 'col-lg-3 col-md-3 col-sm-12 col-xs-12' : 'col-lg-2 col-md-2 col-sm-12 col-xs-12']">
                      <div class="row pt-5 fs-14 text-color font-weight-bold pb-8 pl-0">Site<span data-v-68ffe67c="" aria-hidden="true" class="fa fa-asterisk asterickStyle"></span></div>
                      <div class="show_section siteId">
                        <select
                          class="form-control input-bg select_control"
                          v-model="participant.siteId"
                          v-validate="'required'"
                          :name="`siteId${participant.dynamicInputID}`"
                          :class="{
                            input: true,
                            'is-danger': participant.siteId && errors.has('siteId'),
                            'is-success': !errors.has('siteId')
                          }"
                          @change="
                            validateParticipants(index);
                            populateCountryOptions(participant);
                          "
                        >
                          <option :value="null" disabled>Select site</option>
                          <option :value="site.id" v-for="site in researchSites" :key="site.id">
                            {{ site.userSiteId }}
                          </option>
                        </select>
                      </div>
                      <span v-show="participant.errorSite && errors.has(`siteId${participant.dynamicInputID}`)" class="error-style">Please enter a valid siteId.</span>
                    </div>
                    <div
                      class="pl-0"
                      :class="{
                        'col-lg-2 col-md-2 col-sm-12 col-xs-12': studyData.countryList && studyData.countryList.length > 1 && !(canPiAccess || canSubPIAccess || canStudyCoordinatorAccess || canHomeHealthAccess),
                        'col-lg-3 col-md-3 col-sm-12 col-xs-12': canPiAccess || canSubPIAccess || canStudyCoordinatorAccess || canHomeHealthAccess || (studyData.countryList && studyData.countryList.length <= 1)
                      }"
                    >
                      <div class="row pt-5 fs-14 text-color font-weight-bold pb-8 pl-0">
                        Participant ID
                        <span v-if="!studyData.isParticipantIdRequired">(optional)</span>
                      </div>
                      <input
                        type="text"
                        class="form-control"
                        v-model="participant.userDefinedParticipantId"
                        placeholder="Enter participant ID"
                        v-on:keyup="validateParticipants(index)"
                        v-if="studyData && studyData.participantIdFormatConfigured && !studyData.participantIdFormatConfigured.isFormattingChecked"
                        :class="{
                          'is-danger': studyData && studyData.isParticipantIdRequired && participant.participantConfigurationErrors.length > 0
                        }"
                      />
                      <template v-if="studyData && studyData.participantIdFormatConfigured && studyData.participantIdFormatConfigured.isFormattingChecked">
                        <div
                          class="otp-input scrollbar participant-list"
                          v-for="(format, i) in participant.formattingArray"
                          :key="i"
                          :class="{
                            'not-site-team': !(canPiAccess || canSubPIAccess || canStudyCoordinatorAccess || canHomeHealthAccess)
                          }"
                        >
                          <otpInputService
                            :options="studyData.participantIdFormatConfigured"
                            v-for="(digit, idx) in format.formatArray"
                            :key="idx"
                            v-model="format.formatArray[idx]"
                            :data-fixedCharacters="fixedCharactersIndex"
                            data-page="participantList"
                            @keyup.native="validateParticipants(index)"
                            :class="{
                              'is-danger': participant.participantConfigurationErrors.length > 0
                            }"
                            :showOldFormat="false"
                          ></otpInputService>
                        </div>
                      </template>
                      <div class="error-style" v-if="participant.participantConfigurationErrors && participant.participantConfigurationErrors.length > 0">
                        <div v-for="(error, index) in participant.participantConfigurationErrors" :key="index">
                          {{ error }}
                        </div>
                      </div>
                      <div class="clearfix"></div>
                    </div>
                    <div v-if="studyData.countryList && studyData.countryList.length > 1" class="pl-0 col-lg-3 col-sm-3 col-xs-12">
                      <div class="row pt-5 fs-14 text-color font-weight-bold pb-8 pl-0">
                        Country
                        <span data-v-68ffe67c="" aria-hidden="true" class="fa fa-asterisk asterickStyle"></span>
                      </div>
                      <div class="show_section country">
                        <select
                          class="form-control input-bg select_control"
                          v-model="participant.countryId"
                          v-validate="'required'"
                          :name="`countryId${participant.dynamicInputID}`"
                          :class="{
                            input: true,
                            'is-danger': participant.countryId && errors.has('countryId'),
                            'is-success': !errors.has('countryId')
                          }"
                          @change="
                            validateParticipants(index);
                            populateLanguageOptions(participant);
                          "
                        >
                          <option :value="null" disabled>Select country</option>
                          <option :value="c.countryId" v-for="c in participant.countrySiteOptions" :key="c.countryId">
                            {{ c.countryName }}
                          </option>
                        </select>
                      </div>
                      <span v-show="participant.errorCountry && errors.has(`countryId${participant.dynamicInputID}`)" class="error-style">
                        Participant country is required
                      </span>
                    </div>
                    <div class="pl-0" :class="[(studyData.countryList && studyData.countryList.length > 1) || !(canPiAccess || canSubPIAccess || canStudyCoordinatorAccess || canHomeHealthAccess) ? 'col-lg-2 col-sm-3 col-xs-12' : 'col-lg-3 col-sm-3 col-xs-12']">
                      <div class="row pt-5 fs-14 text-color font-weight-bold pb-8 pl-0">
                        Invitation language
                        <span data-v-68ffe67c="" aria-hidden="true" class="fa fa-asterisk asterickStyle"></span>
                      </div>
                      <div class="show_section langugage">
                        <select
                          class="form-control input-bg select_control"
                          v-model="participant.language"
                          v-validate="'required'"
                          :name="`language${participant.dynamicInputID}`"
                          :class="{
                            input: true,
                            'is-danger': participant.language && errors.has('language'),
                            'is-success': !errors.has('language')
                          }"
                          @change="validateParticipants(index)"
                          :disabled="canSiteDataLockAccess || user.readOnly"
                        >
                          <option :value="null" disabled>Select language</option>
                          <option :value="lang.language_id" v-for="lang in participant.contryWiseLanguages" :key="lang.language_id" :class="{ 'draft-lang': lang.draft }">
                            {{ lang.display_name }}
                          </option>
                        </select>
                      </div>
                      <span v-show="participant.errorLanguage && errors.has(`language${participant.dynamicInputID}`)" class="error-style">Please select language.</span>
                    </div>
                    <div class="cursor_pointer col-lg-1 col-md-1 col-sm-12 col-xs-12" v-if="participantsList.length > 1" @click="removeParticipant(index)">
                      <img src="/static/img/collapse.svg" class="pl-4 pr-7 pt-10" />
                    </div>
                  </div>
                </template>
                <div class="row color_1e8fe1 pb-10">
                  <span class="cursor_pointer" @click="addParticipant">Add another participant</span>
                </div>
                <div class="row color_1e8fe1 pb-10">
                  <span data-v-68ffe67c="" aria-hidden="true" class="fa fa-asterisk asterickStyle fs-7 ml-0 mr-5"></span>
                  <span style="color: black; font-size: 10px">indicates a required field</span>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class>
                <button class="btn mb-10 add-invite-btn br-3 mr-10" :disabled="errors.any() || disableInvite || hasErrorInParticipantList()" @click="inviteParticipantNew(participantsList, false)">
                  Load only, do not invite
                </button>
                <button class="btn mb-10 add-invite-btn br-3" :disabled="errors.any() || disableInvite || hasErrorInParticipantList()" @click="inviteParticipantNew(participantsList, true)">
                  Send invites
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ParticipantTriggerDayZeroModal v-if="studyData.isScheduledStart != undefined" :triggeredParticipant="triggeredParticipant" @resetParticipantDayZeroStatus="resetParticipantDayZeroStatus" :showModal="modalStatus" :studyId="studyId" :piId="user.id" @toggleScheduleModal="toggleScheduleModal" :isScheduledStart="studyData.isScheduledStart"></ParticipantTriggerDayZeroModal>
    <ScheduleStudyStartModal v-if="triggeredParticipant" :participantId="triggeredParticipant.id" :piId="user.id" :showModal="isScheduleStartModalShown" @toggleScheduleModal="toggleScheduleModal" @studyStartScheduled="studyStartScheduled"></ScheduleStudyStartModal>
  </div>
</template>

<script>
import moment from "moment";
import Papa from "papaparse";
import FileSaver from "file-saver";
import cloneDeep from "lodash/cloneDeep";
import max from "lodash/max";
import { AclRule } from "vue-acl";
import map from "lodash/map";
import sortBy from "lodash/sortBy";
import filter from "lodash/filter";
import _ from "lodash";
import $ from "jquery";
import { mapGetters } from "vuex";
import { participantStatuses, participantLanguageText, participantSources, participantStatusesText, participantSourcesText, PI, SUB_PI, STUDY_COORDINATOR, HOME_HEALTH, QUALITY, CRA, DM, SITEDATALOCK, CraUB } from "@/constants/authRoles";
import ParticipantTriggerDayZeroModal from "@/components/participants/participant-trigger-day-zero-modal";
import LocalStorageService from "../../services/localStorage";
import otpInputService from "../services/otp-input-service";
import ScheduleStudyStartModal from "@/components/participants/schedule-study-start-modal";
let dynamicInputID = 0;
export default {
  name: "Participants",
  components: {
    ParticipantTriggerDayZeroModal,
    otpInputService,
    ScheduleStudyStartModal
  },
  props: {
    studyData: Object
  },
  data() {
    return {
      addErrorTitle: "",
      isLoading: false,
      setWithdrawnOrFailedFilter: false,
      selectedLang: "",
      selectedParticipantForChangeStatusValue: {},
      eligibilityScreenQuestionsAnsOfParticipnt: [],
      agreementAcceptedTime: "",
      agreementAcceptedDate: "",
      modalStatus: false,
      uploadFileName: "",
      participantsList: [
        {
          dynamicInputID: dynamicInputID,
          email: "",
          siteId: null,
          language: null,
          countryId: null,
          countrySiteOptions: null,
          participantConfigurationErrors: [],
          linkedLC: {},
          contryWiseLanguages: []
        }
      ],
      getCallDone: false,
      participant: {},
      mismatchEmail: false,
      byInvite: false,
      enableAddInviteBtn: false,
      importPassed: false,
      participantId: null,
      searchTerm: null,
      setImportValue: null,
      exportData: null,
      allParticipants: {},
      totalParticipants: null,
      participantNotInvited: false,
      notInvitedUsers: [],
      batchClick: false,
      userDetails: {
        username: "",
        password: null
      },
      downloadStarted: false,
      downloadCompleted: false,
      afterImporting: false,
      showImporting: false,
      showDefaultImport: true,
      filterTerm: "",
      sourcefilter: "",
      withdrawnOrFailedFilter: "",
      sortValue: "",
      sortOrder: "",
      customKey: "",
      newLabelsList: [],
      participantStatuses,
      participantStatusesText,
      participantSourcesText,
      participantLanguageText,
      newLabel: {},
      updateLabelMode: false,
      addLabelDisable: false,
      addLabelValueMode: false,
      updateLabelValueMode: false,
      newLabelValue: {},
      labelName: "",
      researchSites: [],
      disableInvite: true,
      value: 10,
      skippedParticipants: [],
      displayLanguage: "",
      skippedParticipantsCount: 0,
      fileLength: 0,
      downloadList: {},
      headersAscSortFlags: {
        id: "",
        email: "",
        userDefinedParticipantId: "",
        status: "",
        userSiteId: "",
        participantStudyDays: "",
        participantStudyCompletionPercentage: "",
        participantCompliancePercentage: "",
        participantLanguage: "",
        invitationDate: "",
        source: "",
        registrationDate: ""
      },
      participants: {},
      selectedParticipants: {},
      currentParticipantsList: {},
      currentPage: 1,
      totalPages: 1,
      selectedShowOption: 15,
      participantListOptions: [
        {
          value: 15,
          text: "Show 15 items"
        },
        {
          value: 50,
          text: "Show 50 items"
        },
        {
          value: 100,
          text: "Show 100 items"
        }
      ],
      siteDetails: null,
      isOldProfileViewEnbaled: false,
      triggeredParticipant: null,
      composeParticipants: [],
      composeMessageId: this.$route.query.composeMessageId,
      feature: [],
      fixedCharactersIndex: [],
      recordsWithMissingPIDs: [],
      recordWithOldFormat: [],
      isScheduleStartModalShown: false,
      studyDetails: {},
      recordsWithDuplicatePIDs: [],
      failureReasons: [],
      failureAndDiscontinuedReasons: [],
      selectedStatus: "",
      legacyVal: true
    };
  },
  computed: {
    ...mapGetters(["token", "user"]),
    userAccess() {
      return new AclRule(this.user.userRole).generate();
    },
    userToken() {
      return this.token;
    },
    studyId() {
      return this.$route.params.studyId;
    },
    getStatuses() {
      return participantStatuses;
    },
    getSources() {
      return participantSources;
    },
    getStatusesText() {
      return participantStatusesText;
    },
    canPiAccess() {
      this.$acl.change(`${PI}`);
      return this.$acl.check("userAccess");
    },
    canSubPIAccess() {
      this.$acl.change(`${SUB_PI}`);
      return this.$acl.check("userAccess");
    },
    canStudyCoordinatorAccess() {
      this.$acl.change(`${STUDY_COORDINATOR}`);
      return this.$acl.check("userAccess");
    },
    canQualityAccess() {
      this.$acl.change(`${QUALITY}`);
      return this.$acl.check("userAccess");
    },
    canHomeHealthAccess() {
      this.$acl.change(`${HOME_HEALTH}`);
      return this.$acl.check("userAccess");
    },
    canDMAccess() {
      this.$acl.change(`${DM}`);
      return this.$acl.check("userAccess");
    },
    canCRAccess() {
      this.$acl.change(`${CRA}`);
      return this.$acl.check("userAccess");
    },
    canCraUBAccess() {
      this.$acl.change(`${CraUB}`);
      return this.$acl.check("userAccess");
    },
    canResearchSiteTeamAccess() {
      return this.canPiAccess || this.canSubPIAccess || this.canStudyCoordinatorAccess || this.canHomeHealthAccess;
    },
    canSiteDataLockAccess() {
      this.$acl.change(`${SITEDATALOCK}`);
      return this.$acl.check("userAccess");
    }
  },
  watch: {
    studyData(newData, oldData) {
      if (newData.countryList) {
        this.studyData.countryList = sortBy(newData.countryList, "sortOrder");
      }
      if (newData !== oldData) {
        this.getStudyDetails();
      }
    },
    $route(to) {
      //The below code looks for the route change, so if a user is on this page and clicks on the participants link
      // provided in the left side bar then the below code will act accordingly.
      if (!to.query.composeMessageId) {
        this.composeMessageId = null;
      } else {
        this.composeMessageId = to.query.composeMessageId;
      }
    }
  },
  methods: {
    screeningPassed(participantId, email, siteId) {
      if (this.$route.params.studyId) {
        const data = {
          participantId: participantId,
          siteId: siteId,
          screeningFailed: "0",
          screeningPassed: "1",
          invite: "0",
          email: email,
          participantLocalTime: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZZ"),
          participantLocalOffset: moment().format("Z")
        };
        this.$api
          .postUpatedScreeningStatus(this.$route.params.studyId, data)
          .then(response => {
            if (response) {
              this.getAllParticipants(this.selectedShowOption, this.currentPage, this.searchTerm, this.filterTerm, this.sortValue, this.sortOrder, this.customKey, this.sourcefilter, this.withdrawnOrFailedFilter);
              this.$toastr.success("Screening passed status updated successfully");
            }
          })
          .catch(err => {
            this.$toastr.error("Screening passed status not updated");
            throw err;
          });
      }
    },

    screeningFailed(participantId, email, siteId) {
      if (this.$route.params.studyId) {
        const data = {
          participantId: participantId,
          siteId: siteId,
          screeningFailed: "1",
          screeningPassed: "0",
          invite: "0",
          email: email,
          participantLocalTime: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZZ"),
          participantLocalOffset: moment().format("Z")
        };
        this.$api
          .postUpatedScreeningStatus(this.$route.params.studyId, data)
          .then(response => {
            if (response) {
              this.getAllParticipants(this.selectedShowOption, this.currentPage, this.searchTerm, this.filterTerm, this.sortValue, this.sortOrder, this.customKey, this.sourcefilter, this.withdrawnOrFailedFilter);
              this.$toastr.success("Screening failed status updated successfully");
            }
          })
          .catch(err => {
            this.$toastr.error("Screening failed status not updated");
            throw err;
          });
      }
    },

    invitedParticipant(participantId, email, siteId) {
      if (this.$route.params.studyId) {
        const data = {
          participantId: participantId,
          siteId: siteId,
          screeningFailed: "0",
          screeningPassed: "0",
          invite: "1",
          email: email,
          participantLocalTime: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZZ"),
          participantLocalOffset: moment().format("Z")
        };

        this.$api
          .postUpatedScreeningStatus(this.$route.params.studyId, data)
          .then(response => {
            if (response) {
              this.getAllParticipants(this.selectedShowOption, this.currentPage, this.searchTerm, this.filterTerm, this.sortValue, this.sortOrder, this.customKey, this.sourcefilter, this.withdrawnOrFailedFilter);
              this.$toastr.success("Invited successfully");
            }
          })
          .catch(err => {
            this.$toastr.error("Invitation failed");
            throw err;
          });
      }
    },

    getEligibilityAnswers(participantId) {
      this.isLoading = true;
      this.eligibilityScreenQuestionsAnsOfParticipnt = [];
      this.agreementAcceptedTime = "";
      this.agreementAcceptedDate = "";
      this.displayLanguage = "";
      this.selectedLang = "";
      this.$api
        .getParticipantWebeligibilityAnswers(this.$route.params.studyId, participantId)
        .then(response => {
          if (response) {
            const utcDate = response.data.data.disclaimer_checked_on_utc;
            const m = moment.utc(moment(utcDate, "YYYY-MM-DD HH:mm:ss").toDate());
            this.agreementAcceptedTime = utcDate ? m.format("h:mma").toUpperCase() : "";
            this.displayLanguage = response.data.data.display_language;
            this.selectedLang = this.getLanguageText(this.displayLanguage);
            this.agreementAcceptedDate = utcDate ? moment.utc(utcDate).format("MMMM DD, YYYY") : "";
            if (response.data.data.eligibilityData) {
              this.eligibilityScreenQuestionsAnsOfParticipnt = response.data.data.eligibilityData;
            }
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.isLoading = false;
          throw err;
        });
    },
    hideModal() {
      setTimeout(() => {
        const ifElementExists = document.getElementById("trigger-day-zero-popup");
        if (ifElementExists == undefined) {
          return;
        }
        if (!ifElementExists.classList.contains("show") && this.modalStatus) {
          this.modalStatus = false;
        }
      }, 100);
    },
    getToggledFeatures() {
      this.$api.getToggleFeaturesFact(this.studyId).then(
        response => {
          const toggleFeatures = response.body.studyFeatures;
          this.feature = toggleFeatures.filter(toggledFeature => (toggledFeature.featureKey === "ParticipantStatusActiveWModification" && toggledFeature.enabled === true) || (toggledFeature.featureKey === "ParticipantStatusActiveWModificationV2" && toggledFeature.enabled === true));
          toggleFeatures.forEach(feature => {
            if (feature.featureKey === "OLDPROFILEVIEW") {
              this.isOldProfileViewEnbaled = feature.enabled;
            }
          });
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting features.");
        }
      );
    },
    changeState(participantId) {
      if (this.isOldProfileViewEnbaled) {
        this.$router.push({
          name: "study-participant-details",
          params: { participantId: participantId }
        });
      } else {
        this.$router.push({
          name: "participant-profile",
          params: { participantId: participantId }
        });
      }
      this.setFiltersData(participantId);
    },
    // toggle show more flag for the given index participant
    toggleShowMore(index) {
      this.currentParticipantsList[index].showMore = !this.currentParticipantsList[index].showMore;
      this.$forceUpdate();
    },
    resetParticipantDayZeroStatus(dayZeroStatus) {
      if (!dayZeroStatus) {
        this.modalStatus = false;
        this.triggeredParticipant = null;
        return;
      }
      const self = this;
      const participant = _.find(self.allParticipants, function(p) {
        return p.id === self.triggeredParticipant.id;
      });
      participant.participantStudyStartTrigger.createdBy = this.user.id;
      this.modalStatus = false;
      this.triggeredParticipant = null;
    },
    studyStartScheduled() {
      //In schedule also we are calling this fun bcoz this is just updating the createdBy to hide the study start button
      this.resetParticipantDayZeroStatus(true);
    },
    isSiteTeamMember() {
      return this.canHomeHealthAccess || this.canPiAccess || this.canStudyCoordinatorAccess || this.canSubPIAccess;
    },
    canAccessTriggerBtn(participant) {
      return participant.status == this.getStatuses.VERIFIED;
    },
    triggerDayZeroPopup(participant) {
      this.triggeredParticipant = participant;
      this.modalStatus = true;
    },
    setForNonInvitedUser(participant) {
      this.notInvitedUsers.map(user => {
        if (user.id == participant.id) {
          user.language = participant.language;
        }
      });
    },
    // change the previous page number and update the participants list
    prevPage() {
      if (this.currentPage <= this.totalPages) {
        if (this.getCallDone) {
          this.currentPage -= 1;
          this.getAllParticipants(this.selectedShowOption, this.currentPage, this.searchTerm, this.filterTerm, this.sortValue, this.sortOrder, this.customKey, this.sourcefilter, this.withdrawnOrFailedFilter);
        }
      }
    },
    // change the next page number and update the participants list
    nextPage() {
      if (this.currentPage < this.totalPages) {
        if (this.getCallDone) {
          this.currentPage += 1;
          this.getAllParticipants(this.selectedShowOption, this.currentPage, this.searchTerm, this.filterTerm, this.sortValue, this.sortOrder, this.customKey, this.sourcefilter, this.withdrawnOrFailedFilter);
        }
      }
    },
    // search and filter participants list
    searchParticipantFilterStudies(label) {
      if (this.filterTerm == "WITHDRAWSTUDY") {
        this.withdrawnOrFailedFilter = true;
      } else {
        this.withdrawnOrFailedFilter = false;
      }
      if (!label) {
        this.currentPage = 1;
      }
      this.getAllParticipants(this.selectedShowOption, this.currentPage, this.searchTerm, this.filterTerm, this.sortValue, this.sortOrder, this.customKey, this.sourcefilter, this.withdrawnOrFailedFilter);
    },
    changeWithdrawnOrFailedFilter() {
      this.setWithdrawnOrFailedFilter = !this.setWithdrawnOrFailedFilter;
      this.withdrawnOrFailedFilter = this.setWithdrawnOrFailedFilter === true ? true : "";
      this.getAllParticipants(this.selectedShowOption, this.currentPage, this.searchTerm, this.filterTerm, this.sortValue, this.sortOrder, this.customKey, this.sourcefilter, this.withdrawnOrFailedFilter);
    },
    //sort participants list
    sortList(sortValue, custom) {
      if (custom) {
        this.sortValue = "customLabel";
        this.customKey = sortValue;
      } else {
        this.sortValue = sortValue;
        this.customKey = "";
      }
      this.resetSortValues(sortValue);
      this.headersAscSortFlags[sortValue] = cloneDeep(!this.headersAscSortFlags[sortValue]);
      if (this.headersAscSortFlags[sortValue]) {
        this.sortOrder = "asc";
      } else {
        this.sortOrder = "desc";
      }
      this.currentPage = 1;
      this.getAllParticipants(this.selectedShowOption, this.currentPage, this.searchTerm, this.filterTerm, this.sortValue, this.sortOrder, this.customKey, this.sourcefilter, this.withdrawnOrFailedFilter);
    },
    resetSortValues(sortValue) {
      Object.keys(this.headersAscSortFlags).forEach(key => {
        if (sortValue !== key) {
          this.headersAscSortFlags[key] = "";
        }
      });
    },
    closeModal() {
      let noParticipants = false;
      this.participantsList.forEach(element => {
        if (element.email !== "" || element.siteId !== null || element.language !== "" || element.userDefinedParticipantId || element.countryId !== "" || element.countryId !== null) {
          noParticipants = true;
        }
      });
      if (noParticipants === false) {
        window.$("#add-participant-modal").modal("hide");
        this.participantsList = [
          {
            email: "",
            siteId: null,
            participantConfigurationErrors: []
          }
        ];
        this.otpKindInputLogic();
      } else {
        this.$swal({
          title: "Are you sure you want to cancel? Not saved data will be lost.",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#4a4a4a",
          cancelButtonColor: "#1e8fe1",
          confirmButtonText: "No",
          cancelButtonText: "Yes"
        }).then(({ dismiss }) => {
          if (dismiss === "cancel") {
            window.$("#add-participant-modal").modal("hide");
            this.disableInvite = true;
            this.participantsList = [
              {
                dynamicInputID: dynamicInputID,
                email: "",
                siteId: null,
                language: null,
                countryId: null,
                participantConfigurationErrors: []
              }
            ];
            this.otpKindInputLogic();
          }
        });
      }
    },
    openAddModal() {
      window.$("#add-participant-modal").modal("show");
      if (this.user.userRole !== "Pi" && this.user.userRole !== "SubPi" && this.user.userRole !== "StudyCoordinator" && this.user.userRole !== "HomeHealth") {
        this.getSiteDetails();
      } else {
        //Get the site details when any of the site team user logs in.
        if (this.user.siteIds && this.user.siteIds.length > 0 && !this.siteDetails) {
          this.getSiteDetailsFact();
        } else if (this.siteDetails) {
          //Since the API to get the site details has already been called, no need to call it again
          this.participantsList[0].countrySiteOptions = this.siteDetails.countryList;
          this.participantsList[0].linkedLC = this.siteDetails.linkedCountryLanguages;
          //If there is only one country associated to the site then set it as default selected country
          this.setDefaultCountry(this.participantsList[0], this.siteDetails.countryList);
          this.$forceUpdate();
        }
      }
    },
    downloadTemplate() {
      this.downloadStarted = true;
      this.downloadCompleted = true;
      this.$api.downloadTemplateParticipantDataFact(this.studyId).then(
        response => {
          this.downloadCompleted = false;
          const donwloadFileName = "import_participant.csv";
          //Work around for IE Browsers
          if (window.navigator.msSaveOrOpenBlob) {
            const blobObject = new Blob([response.body]);
            window.navigator.msSaveBlob(blobObject, donwloadFileName);
          } else {
            const csvContent = `data:text/csv;charset=utf-8,${response.body}`;
            const encodedUri = encodeURI(csvContent);
            const link = window.document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", donwloadFileName);
            window.document.body.appendChild(link); // Required for FF
            link.click();
          }

          this.$toastr.success("Participant template downloaded successfully");
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while downlaoding participants.");
        }
      );
    },
    getStudyDetails() {
      if (this.studyData.onboardingType === "ByInvitation") {
        this.byInvite = true;
      }
      // otp-input-service logic
      this.otpKindInputLogic();
    },
    otpKindInputLogic() {
      if (this.studyData && this.studyData.participantIdFormatConfigured && this.studyData.participantIdFormatConfigured.isFormattingChecked) {
        this.studyData.participantIdFormatConfigured.size = this.studyData.participantIdFormatConfigured.size == 0 ? null : this.studyData.participantIdFormatConfigured.size;
        this.participantsList[0]["formattingArray"] = [{ formatArray: [] }];
        this.participantsList[0].formattingArray[0].formatArray.push(JSON.parse(this.studyData.participantIdFormatConfigured.format));
        this.fixedCharactersIndex = [];
        this.participantsList[0].formattingArray[0].formatArray[0].map((ch, index) => {
          if (ch != "" && ch != null) {
            this.fixedCharactersIndex.push(index);
          }
        });
      }
    },
    selectedParticipantForChangeStatus(participant) {
      this.selectedParticipantForChangeStatusValue = participant;
    },
    resetSelectedParticipant() {
      this.selectedParticipantForChangeStatusValue = {};
    },

    createUpdateParticipant(participant, invite) {
      if (this.studyData.isParticipantIdRequired && (participant.userDefinedParticipantId == null || participant.userDefinedParticipantId == "")) {
        this.$toastr.error("Participant is missing with required PID.");
        return;
      } else if (this.checkIfParticipantIdFormatHasBeenChanged(participant)) {
        this.$toastr.error("Participant's PID not in the set up format.");
        return;
      }
      const p = this.processTheLanguageKey(participant);
      const participantData = cloneDeep(p);
      participantData.sendInvite = invite;
      const payload = {
        studyId: this.studyId,
        participantId: participantData.id,
        data: participantData
      };
      this.$api.updateParticipantInfoFact(payload).then(
        () => {
          this.$toastr.success("Participants updated successfully");
          this.$router.push({
            name: "study-participants-list",
            params: { studyId: this.studyId }
          });
          this.getAllParticipants(this.selectedShowOption, this.currentPage, this.searchTerm, this.filterTerm, this.sortValue, this.sortOrder, this.customKey, this.sourcefilter, this.withdrawnOrFailedFilter);
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while updating participant.");
        }
      );
    },

    resendVerification(participant) {
      const payload = {
        studyId: this.studyId,
        participantId: participant.id
      };
      this.$api.resendVerificationFact(payload).then(
        () => {
          this.$toastr.success("Verification email sent");
          this.$router.push({
            name: "study-participants-list",
            params: { studyId: this.studyId }
          });
          this.getAllParticipants(this.selectedShowOption, this.currentPage, this.searchTerm, this.filterTerm, this.sortValue, this.sortOrder, this.customKey, this.sourcefilter, this.withdrawnOrFailedFilter);
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while updating participants.");
        }
      );
    },

    getAllParticipants(selectedShowOption, currentPage, search, filter, sortValue, sortOrder, customKey, sourcefilter, withdrawnOrFailedFilter) {
      this.$api
        .getParticipantsListFact(
          this.studyId,
          selectedShowOption,
          currentPage,
          search,
          filter,
          sortValue,
          sortOrder,
          customKey,
          sourcefilter,
          "", //cohortFilter
          "", //siteDocumentId
          "", //languageId
          "", //activateForMoreParticipants
          withdrawnOrFailedFilter
        )
        .then(
          response => {
            this.allParticipants = response.body.participants;
            this.allParticipants = this.processParticipant(this.allParticipants);
            this.totalParticipants = response.body.totalParticipants;
            this.participantNotInvited = response.body.isParticipantNotInvited;
            this.totalPages = response.body.totalPages;
            this.currentPage = response.body.currentPage;
            this.participants = this.allParticipants;
            this.currentParticipantsList = this.allParticipants;
            this.currentParticipantsList.forEach((element, index) => {
              this.currentParticipantsList[index].showMore = false;
            });
            this.getCallDone = true;
          },
          error => {
            this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting participants.");
          }
        );
      this.getCallDone = false;
    },
    // Show the participants list in the table as per the number selected
    showParticipants(selectedShowOption) {
      this.getAllParticipants(selectedShowOption, 1, this.searchTerm, this.filterTerm, this.sortValue, this.sortOrder, this.customKey, this.sourcefilter, this.withdrawnOrFailedFilter);
    },

    viewParticipant(participantId) {
      this.$router.push({
        name: "add-edit-participant",
        params: { participantId }
      });
    },

    getSiteDetails() {
      this.$api.getSitesFact(this.studyId).then(
        response => {
          this.researchSites = sortBy(response.body, "createdTime");
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting the list of sites");
        }
      );
    },

    addParticipant() {
      this.disableInvite = true;
      dynamicInputID++;
      const particpantInviteObj = {
        dynamicInputID: dynamicInputID,
        email: "",
        siteId: null,
        language: null,
        countryId: null,
        participantConfigurationErrors: []
      };
      if (this.siteDetails) {
        particpantInviteObj.countrySiteOptions = this.siteDetails.countryList;
        particpantInviteObj.linkedLC = this.siteDetails.linkedCountryLanguages;
        //If there is only one country associated to the site then set it as default selected country
        this.setDefaultCountry(particpantInviteObj, this.siteDetails.countryList);
      }
      if (this.studyData.participantIdFormatConfigured.isFormattingChecked) {
        particpantInviteObj["formattingArray"] = [{ formatArray: [] }];
        particpantInviteObj.formattingArray[0].formatArray.push(JSON.parse(this.studyData.participantIdFormatConfigured.format));
      }
      this.participantsList.push(particpantInviteObj);
      this.populateLanguageOptions(particpantInviteObj);
      this.disableInvite = true;
    },

    removeParticipant(index) {
      this.participantsList.splice(index, 1);
      this.participantsList.forEach((element, i) => {
        this.validateParticipants(i);
      });
    },

    validateParticipants(index) {
      this.disableInvite = true;
      this.participantsList[index].emailError = false;
      if (this.user.userRole === "Pi" || this.user.userRole === "SubPi" || this.user.userRole === "StudyCoordinator" || this.user.userRole === "HomeHealth") {
        const siteId = this.user.siteIds[0];
        this.participantsList[index].siteId = siteId;
      }

      if (this.errors.has(`email${this.participantsList[index].dynamicInputID}`) || this.participantsList[index].email.trim() == "") {
        this.participantsList[index].emailError = true;
        this.disableInvite = true;
        this.$forceUpdate();
      }
      if (this.participantsList[index].siteId === null) {
        this.participantsList[index].errorSite = true;
        this.disableInvite = true;
      } else {
        this.participantsList[index].errorSite = false;
      }
      if (!this.studyData.participantIdFormatConfigured.isFormattingChecked && this.studyData.isParticipantIdRequired && (this.participantsList[index].userDefinedParticipantId == null || this.participantsList[index].userDefinedParticipantId == "" || this.participantsList[index].userDefinedParticipantId.trim() == "")) {
        this.participantsList[index].participantConfigurationErrors = ["Participant ID is required."];
        this.participantsList[index].errorParticipant = true;
        this.disableInvite = true;
      } else if (this.studyData.participantIdFormatConfigured.isFormattingChecked) {
        this.participantsList[index].participantConfigurationErrors = this.checkForParticipantIdConfiguration(this.participantsList[index]);
        this.participantsList[index].errorParticipant = this.participantsList[index].participantConfigurationErrors.length > 0;
        this.disableInvite = this.participantsList[index].participantConfigurationErrors.length > 0;
      } else {
        this.participantsList[index].participantConfigurationErrors = [];
        this.participantsList[index].errorParticipant = false;
      }
      if (this.participantsList[index].language === null) {
        this.participantsList[index].errorlanguage = true;
        this.disableInvite = true;
      } else {
        this.participantsList[index].errorlanguage = false;
      }
      if (this.participantsList[index].countryId == null) {
        this.participantsList[index].errorCountry = true;
        this.disableInvite = true;
      } else {
        this.participantsList[index].errorCountry = false;
      }

      this.$nextTick(function() {
        if (this.participantsList[index].email.trim() != "" && !this.participantsList[index].errorSite && !this.participantsList[index].errorCountry && !this.participantsList[index].errorlanguage && !this.participantsList[index].errorParticipant) {
          this.disableInvite = false;
        }
      });

      this.$forceUpdate();
    },

    inviteParticipant(list, invite) {
      const self = this;
      let totalCount = 0;
      let successCount = 0;
      const addedList = filter(list, o => !o.added);
      addedList.forEach(async participant => {
        const data = participant;
        data.sendInvite = invite;
        try {
          await self.$api.addNewParticipantInfoFact(self.studyId, data);
          data.added = true;
          self.$forceUpdate();
          self.validate(list);
          totalCount += 1;
          successCount += 1;
          self.showMessage(successCount, invite, totalCount, addedList.length);
        } catch (error) {
          data.added = false;
          self.validate(list);
          data.emailError = true;
          self.$forceUpdate();
          totalCount += 1;
          self.showMessage(successCount, invite, totalCount, addedList.length);
          self.$toastr.error(error.body && error.body.message ? error.body.message : "Error while adding participants.");
        }
      });
    },
    processTheLanguageKey(list) {
      if (Array.isArray(list)) {
        list.map(participant => {
          participant.languageKey = participant.language;
          delete participant.language;
          delete participant.countrySiteOptions;
        });
      } else {
        const participantObj = { ...list };
        participantObj.languageKey = participantObj.language;
        delete participantObj.language;
        delete participantObj.countrySiteOptions;
        return participantObj;
      }
    },
    checkForParticipantIdConfiguration(list) {
      const errors = [];
      const participantIdList = _.cloneDeep(list);
      // remove fixed characters from the string.
      const characters = participantIdList.formattingArray[0].formatArray[0].filter((ch, index) => {
        if (this.fixedCharactersIndex.indexOf(index) == -1 && ch != null) {
          return ch;
        }
      });
      // check for pid is required or not, pid length,
      if (characters.length == 0 && this.studyData.isParticipantIdRequired) {
        errors.push("Participant ID is required.");
      } else if (characters.length != 0 && characters.length != this.studyData.participantIdFormatConfigured.size - this.fixedCharactersIndex.length) {
        errors.push("Incorrect PID length.");
      }

      if (errors.length > 0) {
        return errors;
      }

      const PID = characters.join("");
      if (this.studyData.participantIdFormatConfigured.isDisallowLetters && /[a-zA-Z]/g.test(PID)) {
        errors.push("Letters are not allowed.");
      } else if (this.studyData.participantIdFormatConfigured.isDisallowNumbers && /[0-9]/g.test(PID)) {
        errors.push("Numbers are not allowed");
      } else if (this.studyData.participantIdFormatConfigured.isDisallowSpecialCharacters && /[[\\\];=!@#$%^&*(),'_.?":{}|<>+~/`-]/g.test(PID)) {
        errors.push("Special characters are not allowed");
      }
      return errors;
    },
    processTheParticipantId(list) {
      if (list.length == 0) {
        return;
      }
      list.map(participant => {
        // remove fixed characters from the string.
        let characters = participant.formattingArray[0].formatArray[0];
        if (this.fixedCharactersIndex.length > 0) {
          characters = participant.formattingArray[0].formatArray[0].filter((ch, index) => {
            if (this.fixedCharactersIndex.indexOf(index) == -1) {
              return ch;
            }
          });
        }
        participant.userDefinedParticipantId = characters.length == 0 ? null : participant.formattingArray[0].formatArray[0].join("");
      });
    },
    inviteParticipantNew(list, invite) {
      this.addErrorTitle = "";
      if (this.studyDetails.allowDuplicatePid == true) {
        this.$swal({
          title: "This Participant ID is currently in use. If you choose to proceed, this PID will be assigned to more than one participant. Would you like to proceed?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#b8c7ce",
          cancelButtonColor: "#f16559",
          confirmButtonText: "Cancel",
          cancelButtonText: "Yes"
        }).then(({ dismiss }) => {
          if (dismiss === "cancel") {
            this.disableInvite = true;
            this.processTheLanguageKey(list);
            if (this.studyData.participantIdFormatConfigured.isFormattingChecked) {
              this.processTheParticipantId(list);
            }
            this.$api.addParticipantListFact(this.studyId, invite, list).then(
              response => {
                this.downloadList = response.body;
                this.skippedParticipants = response.body.skippedParticipants;
                this.skippedParticipantsCount = response.body.skippedParticipantsCount;
                window.$("#add-participant-modal").modal("hide");
                if (this.skippedParticipantsCount > 0) {
                  this.addErrorTitle = invite ? "Invite" : "Load";
                  window.$("#add-error-modal").modal("show");
                  window.$("#add-error-modal").on("shown.bs.modal", function() {
                    $("body").addClass("modal-open");
                  });
                }
                if (response.body.importParticipantsCount > 0) {
                  if (invite) {
                    this.$toastr.success(`${response.body.importParticipantsCount} Participant(s) invited`);
                  } else {
                    this.$toastr.success(`${response.body.importParticipantsCount} Participant(s) loaded`);
                  }
                }
                this.getAllParticipants(this.selectedShowOption, this.currentPage);
                this.filterTerm = "";
                this.searchTerm = "";
                this.sourcefilter = "";
                this.withdrawnOrFailedFilter = "";
                this.resetSortValues("");
                this.participantsList = [
                  {
                    email: "",
                    siteId: null,
                    language: null,
                    countryId: null,
                    countrySiteOptions: null,
                    participantConfigurationErrors: []
                  }
                ];
                this.otpKindInputLogic();
              },
              error => {
                this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while adding participants.");
              }
            );
          }
        });
      } else {
        this.disableInvite = true;
        this.processTheLanguageKey(list);
        if (this.studyData.participantIdFormatConfigured.isFormattingChecked) {
          this.processTheParticipantId(list);
        }
        this.$api.addParticipantListFact(this.studyId, invite, list).then(
          response => {
            this.downloadList = response.body;
            this.skippedParticipants = response.body.skippedParticipants;
            this.skippedParticipantsCount = response.body.skippedParticipantsCount;
            window.$("#add-participant-modal").modal("hide");
            if (this.skippedParticipantsCount > 0) {
              this.addErrorTitle = invite ? "Invite" : "Load";
              window.$("#add-error-modal-modal").modal("show");
              window.$("#add-error-modal-modal").on("shown.bs.modal", function() {
                $("body").addClass("modal-open");
              });
            }
            if (response.body.importParticipantsCount > 0) {
              if (invite) {
                this.$toastr.success(`${response.body.importParticipantsCount} Participant(s) invited`);
              } else {
                this.$toastr.success(`${response.body.importParticipantsCount} Participant(s) loaded`);
              }
            }
            this.getAllParticipants(this.selectedShowOption, this.currentPage);
            this.filterTerm = "";
            this.searchTerm = "";
            this.sourcefilter = "";
            this.withdrawnOrFailedFilter = "";
            this.resetSortValues("");
            this.participantsList = [
              {
                email: "",
                siteId: null,
                language: null,
                countryId: null,
                countrySiteOptions: null,
                participantConfigurationErrors: []
              }
            ];
            this.otpKindInputLogic();
          },
          error => {
            this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while adding participants.");
          }
        );
      }
    },
    getStudyDetailsFact() {
      this.$api.getStudyDetailsFactV2(this.studyId).then(
        response => {
          this.studyDetails = response.body;
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting study detail.");
        }
      );
    },
    showMessage(successCount, invite, count, length) {
      if (count === length) {
        if (invite) {
          this.$toastr.success(`${successCount} Participant(s) invited`);
        } else {
          this.$toastr.success(`${successCount} Participant(s) imported`);
        }
      }
    },
    validate(list) {
      const addedList = filter(list, o => o.added);
      if (addedList.length === list.length) {
        this.getAllParticipants(this.selectedShowOption, this.currentPage);
        this.filterTerm = "";
        this.searchTerm = "";
        this.sourcefilter = "";
        this.withdrawnOrFailedFilter = "";
        this.resetSortValues("");
        window.$("#add-participant-modal").modal("hide");
        this.participantsList = [
          {
            email: "",
            siteId: null,
            language: null,
            countryId: null,
            countrySiteOptions: null,
            participantConfigurationErrors: []
          }
        ];
        this.otpKindInputLogic();
      }
    },

    goToEditParticipantProfile() {
      this.editable = false;
    },

    closeImportModal() {
      window.$("#batch-import-modal").modal("hide");
      this.setImportValue = null;
      window.$('#file_upload[type="file"]').val(null);
    },
    closeAddErrorModal() {
      window.$("#add-error-modal").modal("hide");
      window.$("#add-error-modal").on("hidden.bs.modal", function() {
        $("body").removeClass("modal-open");
      });
    },
    closeDownloadModal() {
      window.$("#download-report-modal").modal("hide");
      window.$("#download-report-modal").on("hidden.bs.modal", function() {
        $("body").removeClass("modal-open");
      });
    },
    onFileChange() {
      const fd = new FormData();
      const input = window.document.getElementById("file_upload");
      fd.append("file", input.files[0]);
      fd.append("sendInvite", false);
      this.setImportValue = fd;
      this.uploadFileName = input.files[0].name;
      Papa.parse(input.files[0], {
        complete: results => {
          const data = filter(results.data, o => o.length === 5);
          this.fileLength = data.length - 1;
          window.$("#add-participant-modal").modal("hide");
          if (data.length - 1 > 0 && (data[0][0] === "Participant email address" || data[0][0] === " Participant email address") && data[0][1] === "Site ID" && data[0][2] === "Participant ID" && data[0][3] === "Language" && data[0][4] === "Country") {
            window.$("#batch-import-modal").modal("show");
          } else {
            this.$toastr.error("Uploaded file is not in the expected format. Please use the batch upload template.");
          }
        }
      });
      this.$forceUpdate();
      window.document.getElementById("file_upload").value = null;
    },
    uploadAnotherCSV() {
      this.showDefaultImport = true;
      this.afterImporting = false;
      this.setImportValue = null;
    },
    importCSV(setImportValue) {
      this.fileName = this.uploadFileName;
      this.showDefaultImport = false;
      this.showImporting = true;
      this.closeImportModal();
      window.$("#uploading-modal").modal("show");
      this.value = 0;
      window.setInterval(() => {
        this.value = this.value + 10;
      }, 100);
      this.$forceUpdate();
      this.$api.importParticipantDataFact(this.studyId, setImportValue).then(
        response => {
          this.importPassed = true;
          this.showImporting = false;
          this.afterImporting = true;
          this.skippedParticipants = response.body.skippedParticipants;
          this.skippedParticipantsCount = response.body.skippedParticipantsCount;
          if (response.body.importParticipantsCount > 0) {
            this.$toastr.success(`${response.body.importParticipantsCount} Participant(s) loaded`);
          }
          this.downloadList = response.body;
          this.getAllParticipants(this.selectedShowOption, this.currentPage);
          this.searchTerm = "";
          this.filterTerm = "";
          this.sourcefilter = "";
          this.withdrawnOrFailedFilter = "";
          this.resetSortValues("");
          this.setImportValue = null;
          this.value = 100;
          window.clearInterval();
          window.$("#uploading-modal").modal("hide");
          window.$("#download-report-modal").modal("show");
          window.$("#download-report-modal").on("shown.bs.modal", function() {
            $("body").addClass("modal-open");
          });
          this.$forceUpdate();
          this.participantsList = [
            {
              dynamicInputID: dynamicInputID,
              email: "",
              siteId: null,
              language: null,
              countryId: null
            }
          ];
        },
        error => {
          this.importPassed = false;
          window.clearInterval();
          window.$("#uploading-modal").modal("hide");
          window.$("#download-report-modal").modal("show");
          window.$("#download-report-modal").on("shown.bs.modal", function() {
            $("body").addClass("modal-open");
          });
          this.$forceUpdate();
          this.showImporting = false;
          this.afterImporting = true;
          this.setImportValue = null;
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while uploading participants csv.");
        }
      );
    },
    getDateStamp() {
      const now = new Date();
      const month = now.getMonth() + 1;
      const day = now.getDate();
      const year = now.getFullYear();
      const hours = now.getHours();
      const mins = `0${now.getMinutes()}`.slice(-2);
      return `${month}-${day}-${year}-${hours}-${mins}`;
    },
    download() {
      this.downloadStarted = true;
    },
    downloadAgain() {
      this.downloadStarted = false;
      this.userDetails.password = null;
      this.errors.clear();
    },
    exportCSV() {
      const fileName = `participants_${this.getDateStamp()}.csv`;
      const ua = navigator.userAgent.toLowerCase();
      let type = "";
      if (ua.indexOf("safari") !== -1) {
        if (!(ua.indexOf("chrome") > -1 || ua.indexOf("crios") > -1)) {
          type = "attachment/csv;charset=utf-8";
        }
      }
      type = "text/csv;charset=utf-8";
      const list = [];
      this.downloadList.skippedParticipants.forEach(element => {
        list.push({
          "Participant email address": element.email,
          "Site ID": element.siteId,
          "Participant ID": element.participantId,
          Status: "failed",
          "Failure reason": element.reason
        });
      });
      this.downloadList.importParticipants.forEach(element => {
        list.push({
          "Participant email address": element.email,
          "Site ID": element.siteId,
          "Participant ID": element.participantId,
          Status: "imported",
          "Failure reason": element.reason
        });
      });
      const csv = Papa.unparse(list);
      const blob = new Blob([csv], { type });
      FileSaver.saveAs(blob, fileName);
    },
    batchInvite() {
      this.getNotInvitedUserList(true);
      this.recordsWithMissingPIDs = [];
      this.recordsWithDuplicatePIDs = [];
      this.recordWithOldFormat = [];
      window.$("#invite-all-modal").modal("show");
    },
    inviteAll() {
      const batchInviteList = [];
      this.recordsWithMissingPIDs = [];
      this.recordsWithDuplicatePIDs = [];
      this.recordWithOldFormat = [];
      const self = this;
      this.notInvitedUsers.forEach(user => {
        let currentlanguage;
        self.currentParticipantsList.forEach(element => {
          if (element.id == user.id) {
            currentlanguage = element.language;
          }
        });
        const par = {};
        par.participantId = user.id;
        par.languageKey = currentlanguage || user.language;
        if (this.studyData.isParticipantIdRequired && (user.userDefinedParticipantId == undefined || user.userDefinedParticipantId == "")) {
          this.recordsWithMissingPIDs.push(user);
        } else if (this.checkIfParticipantIdFormatHasBeenChanged(user)) {
          this.recordWithOldFormat.push(user);
        } else {
          batchInviteList.push(par);
        }
      });
      if (batchInviteList.length == 0) {
        if (this.recordsWithMissingPIDs.length > 0 || this.recordWithOldFormat.length > 0) {
          window.$("#invite-all-modal").modal("show");
        } else {
          window.$("#invite-all-modal").modal("hide");
        }
        return;
      }
      this.$api.batchInviteInfoFact(this.studyId, batchInviteList).then(
        response => {
          const keys = Object.keys(response.body);
          const invitedLength = batchInviteList.length - keys.length;
          if (invitedLength > 0) {
            this.$toastr.success(`${invitedLength} participant(s) invited.`);
            if (this.recordsWithMissingPIDs.length > 0 || this.recordWithOldFormat.length > 0) {
              window.$("#invite-all-modal").modal("show");
            } else {
              window.$("#invite-all-modal").modal("hide");
            }
          } else {
            const results = JSON.parse(JSON.stringify(response.body));
            let count = 0;
            this.recordsWithDuplicatePIDs = [];

            for (let index = 0; index < keys.length; index++) {
              const element = results[keys[index]];
              if (element === "The following records have duplicate PID.") {
                const objPar = {};
                objPar.email = keys[index];
                this.recordsWithDuplicatePIDs.push(objPar);
                count++;
              }
            }

            if (count > 0) {
              window.$("#invite-all-modal").modal("show");
            } else {
              window.$("#invite-all-modal").modal("hide");
            }

            this.$toastr.error(`${keys.length} participant(s) invitation failed.`);
          }
          this.getAllParticipants(this.selectedShowOption, this.currentPage);
          this.searchTerm = "";
          this.filterTerm = "";
          this.sourcefilter = "";
          this.withdrawnOrFailedFilter = "";
          this.resetSortValues("");
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting participants.");
        }
      );
    },
    getUniqueNotInvitedUser() {
      const result = [];
      const map = new Map();
      for (const item of this.notInvitedUsers) {
        if (!map.has(item.id)) {
          map.set(item.id, true); // set any value to Map
          result.push(item);
        }
      }
      this.notInvitedUsers = result;
    },
    cancelInvite() {
      window.$("#invite-all-modal").modal("hide");
      this.recordsWithMissingPIDs = [];
      this.recordWithOldFormat = [];
    },
    clearImport() {
      this.showDefaultImport = true;
      window.$("#import-participant-modal").modal("hide");
      this.afterImporting = false;
      this.showImporting = false;
    },
    addNewLabel() {
      let maxIndex = Number(max(map(this.newLabelsList, "keyReference")));
      maxIndex = maxIndex || 1;
      if (this.newLabelsList.length > 0) {
        if (this.newLabelsList[this.newLabelsList.length - 1].id) {
          this.newLabel = { keyReference: maxIndex + 1, key: "", value: "" };
          this.newLabelsList.push(this.newLabel);
        } else {
          this.$toastr.error("Custom label value should not be empty");
        }
      } else {
        this.newLabel = { keyReference: maxIndex + 1, key: "", value: "" };
        this.newLabelsList.push(this.newLabel);
      }
      this.addLabelDisable = true;
      this.updateLabelMode = false;
    },
    getCustomLabels() {
      this.$api.getLabelsFact(this.studyId).then(
        response => {
          this.newLabelsList = sortBy(response.body, "keyReference");
          response.body.forEach(element => {
            this.headersAscSortFlags[element.key] = "";
          });
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while adding label.");
        }
      );
    },
    createUpdateLabelCallback(index, response) {
      this.newLabelsList.splice(index, 1, response);
      this.newLabel = {};
      this.addLabelDisable = false;
      this.updateLabelMode = false;
    },
    createUpdateLabel(item, index) {
      if (item.keyReference) {
        if (this.updateLabelMode) {
          this.$api.updateNewLabelFact(this.studyId, item.id, item).then(
            response => {
              this.createUpdateLabelCallback(index, response.body);
            },
            error => {
              this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while adding label.");
            }
          );
        } else {
          this.$api.addNewLabelFact(this.studyId, item).then(
            response => {
              this.headersAscSortFlags[item.key] = "";
              this.createUpdateLabelCallback(index, response.body);
            },
            error => {
              this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while adding label.");
            }
          );
        }
      }
    },
    updateLabel(item) {
      this.newLabel = cloneDeep(item);
      this.addLabelDisable = true;
      this.updateLabelMode = true;
    },
    discardChanges() {
      this.newLabel = {};
      this.addLabelDisable = false;
      this.updateLabelMode = false;
    },
    deleteLabelCallback(index) {
      this.newLabelsList.splice(index, 1);
      this.newLabel = {};
      this.addLabelDisable = false;
      this.updateLabelMode = false;
    },
    deleteLabel(index, item) {
      this.$swal({
        title: "Are you sure you want to delete?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#b8c7ce",
        cancelButtonColor: "#f16559",
        confirmButtonText: "Cancel",
        cancelButtonText: "Delete"
      }).then(({ dismiss }) => {
        if (dismiss === "cancel") {
          if (item.keyReference) {
            if (this.updateLabelMode) {
              this.$api.deleteNewLabelFact(this.studyId, item.id).then(
                () => {
                  this.deleteLabelCallback(index);
                  this.getAllParticipants(this.selectedShowOption, this.currentPage);
                  this.searchTerm = "";
                  this.filterTerm = "";
                  this.sourcefilter = "";
                  this.withdrawnOrFailedFilter = "";
                  this.resetSortValues("");
                },
                error => {
                  this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while adding label.");
                }
              );
            } else {
              this.deleteLabelCallback(index);
            }
          }
        }
      });
    },
    addLabelValue(participant, item) {
      this.newLabelValue = cloneDeep(item);
      this.newLabelValue[this.newLabelValue.key] = "";
      this.newLabelValue.participantId = participant.id;
      this.newLabelValue[item.key] = "";
    },
    createUpdateLabelValue(newLabelValue, participant) {
      const newLabel = cloneDeep(newLabelValue);
      this.updateLabelValueMode = false;
      if (newLabelValue.key !== "") {
        newLabel.email = participant.email;
        newLabel.id = newLabel.participantId;
        newLabel.sendInvite = false;
        const pData = {
          studyId: this.studyId,
          participantId: participant.id,
          data: newLabel
        };
        this.$api.addNewLabelValueFact(pData).then(
          () => {
            this.searchParticipantFilterStudies("label");
            this.newLabelValue = {};
          },
          error => {
            this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while adding label.");
          }
        );
      } else {
        this.$toastr.error("Please enter a value for the label.");
      }
    },
    discardLabelValueChanges() {
      this.newLabelValue = {};
      this.updateLabelValueMode = false;
    },
    updateLabelValue(newLabelValue, participant) {
      const newLabel = cloneDeep(newLabelValue);
      const value = participant[newLabel.key];
      newLabel[newLabel.key] = value;
      newLabel.participantId = participant.id;
      this.newLabelValue = newLabel;
    },
    getStatusText(participant) {
      return this.participantStatusesText[participant.status];
    },
    getSourceText(participant) {
      return this.participantSourcesText[participant.source];
    },
    getLanguageText(language) {
      return this.participantLanguageText[language];
    },
    canInviteParticipants() {
      const rolesNotInviteParticipants = [CRA, DM, QUALITY, SITEDATALOCK, CraUB];
      return !_.includes(rolesNotInviteParticipants, this.user.userRole);
    },
    processParticipant(allParticipants) {
      if (allParticipants && allParticipants.length == 0) {
        return allParticipants;
      }
      allParticipants.map(participant => {
        if (participant != undefined) {
          if (participant.participantLanguage != undefined) {
            participant.language = participant.participantLanguage.language_id;
          }
        }
        if (!!participant.linkedLanguages == false) {
          participant.linkedLanguages = this.studyData.studyLanguage;
        }

        participant.disabled = true;
        if (participant.status == this.getStatuses.NOTINVITED || participant.status == this.getStatuses.INVITED) {
          participant.disabled = false;
        }
      });

      return allParticipants;
    },
    getNotInvitedUserList(flag) {
      this.notInvitedUsers = [];
      this.$api.getNotInvitedParticipantsFact(this.studyId).then(
        response => {
          response.body.forEach(part => {
            this.notInvitedUsers.push(part);
          });
          if (flag) {
            this.getUniqueNotInvitedUser();
          }
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting not invited participants.");
        }
      );
    },
    populateLanguageOptions(participant) {
      const languagesList = participant.linkedLC[participant.countryId];
      if (this.participantsList.indexOf(participant) != -1) {
        this.participantsList[this.participantsList.indexOf(participant)].contryWiseLanguages = languagesList;
      }
    },
    populateCountryOptions(participantObj) {
      const selectedSiteObj = filter(this.researchSites, {
        id: participantObj.siteId
      });
      const siteCountries = selectedSiteObj[0].countryList;
      const siteCountryLanguages = selectedSiteObj[0].linkedCountryLanguages;
      participantObj.countrySiteOptions = siteCountries;
      participantObj.linkedLC = siteCountryLanguages;
      //If there is only one country associated to the site then set it as default selected country
      this.setDefaultCountry(participantObj, siteCountries);
    },
    getSiteDetailsFact() {
      this.$api.getSiteDetailsFact(this.studyId, this.user.siteIds[0]).then(
        response => {
          this.siteDetails = response.body;
          this.participantsList[0].countrySiteOptions = this.siteDetails.countryList;
          this.participantsList[0].linkedLC = this.siteDetails.linkedCountryLanguages;
          //If there is only one country associated to the site then set it as default selected country
          this.setDefaultCountry(this.participantsList[0], this.siteDetails.countryList);
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting the site details.");
        }
      );
    },
    setDefaultCountry(participantObj, siteCountries) {
      if (siteCountries.length == 1) {
        //If there is only one country associated to the site then set it as default selected country
        participantObj.countryId = siteCountries[0].countryId;
        participantObj.errorCountry = false;
        participantObj.contryWiseLanguages = participantObj.linkedLC[participantObj.countryId];
        this.populateLanguageOptions(participantObj);
      } else {
        participantObj.countryId = null;
        participantObj.errorCountry = true;
      }
    },
    hasErrorInParticipantList() {
      const emptyItems = filter(this.participantsList, participant => {
        return participant.email.trim() == "" || participant.siteId == null || participant.language == null || participant.countryId == null || participant.emailError || participant.errorSite || participant.errorlanguage || participant.errorCountry;
      });
      if (emptyItems.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    isNull(v) {
      if (typeof v === "string" || v instanceof String) {
        return v || "";
      }
      return "";
    },
    setFiltersData(pid) {
      let participantFilters = LocalStorageService.getItem("participants-filter-map");
      participantFilters = participantFilters ? new Map(JSON.parse(participantFilters)) : new Map();
      const filters = {
        pageSize: Number(this.selectedShowOption),
        search: this.isNull(this.searchTerm),
        filter: this.isNull(this.filterTerm),
        sortValue: this.isNull(this.sortValue),
        sortOrder: this.isNull(this.sortOrder),
        customKey: this.isNull(this.customKey),
        sourcefilter: this.isNull(this.sourcefilter),
        withdrawnOrFailedFilter: this.isNull(this.withdrawnOrFailedFilter)
      };
      participantFilters.set(this.studyId + "-" + pid, filters);
      LocalStorageService.setItem("participants-filter-map", [...participantFilters]);
    },
    backToComposeMessage() {
      if (LocalStorageService.getItem(this.composeMessageId) === null || LocalStorageService.getItem(this.composeMessageId) === undefined) {
        this.$toastr.error("Something went wrong, please start from the compose process again.");
      } else {
        const comMsgObj = LocalStorageService.getItem(this.composeMessageId);
        comMsgObj.participantList = this.composeParticipants;
        LocalStorageService.setItem(this.composeMessageId, comMsgObj);
        this.$router.push({
          name: "study-participant-compose-message",
          params: { composeMessageId: this.composeMessageId }
        });
      }
    },
    checkIfFixedCharactersAreSame(participant) {
      let isFormatUpdate = false;
      if (!this.studyData) {
        return;
      }
      const fixedCharactersIndex = [];
      const formatArr = JSON.parse(this.studyData.participantIdFormatConfigured.format);
      formatArr.map((ch, index) => {
        if (ch != "" && ch != null) {
          fixedCharactersIndex.push({ index: index, character: ch });
        }
      });

      for (let i = 0; i < fixedCharactersIndex.length; i++) {
        if (fixedCharactersIndex[i].character != participant.userDefinedParticipantId[fixedCharactersIndex[i].index]) {
          isFormatUpdate = true;
          break;
        }
      }
      return isFormatUpdate;
    },
    ifParticipantIDIsRequired(participant) {
      // if participant id is not requred and PID is empty
      if (!this.studyData.isParticipantIdRequired && (participant.userDefinedParticipantId != "" || participant.userDefinedParticipantId != null)) {
        return false;
      }
      return true;
    },
    checkIfParticipantIdFormatHasBeenChanged(element) {
      if (this.studyData && !this.studyData.participantIdFormatConfigured.isFormattingChecked) {
        return false;
      }
      // check user define participant id with latest one.
      // check if size is equal to latest format then only fetch fixed characters
      if ((this.studyData && this.studyData.participantIdFormatConfigured.size) != (element.userDefinedParticipantId && element.userDefinedParticipantId.length)) {
        return this.ifParticipantIDIsRequired(element);
      } else if ((this.studyData && this.studyData.participantIdFormatConfigured.size) == (element.userDefinedParticipantId && element.userDefinedParticipantId.length)) {
        if (!this.checkIfFixedCharactersAreSame(element)) {
          // check for dissallow characters
          if (element.userDefinedParticipantId.length > 0) {
            const charArr = element.userDefinedParticipantId.split("");
            const characters = charArr.filter((ch, index) => {
              if (this.fixedCharactersIndex.indexOf(index) == -1 && ch != null) {
                return ch;
              }
            });
            const PID = characters.join("");
            if (this.studyData.participantIdFormatConfigured.isDisallowLetters && /[a-zA-Z]/g.test(PID)) {
              return true;
            } else if (this.studyData.participantIdFormatConfigured.isDisallowNumbers && /[0-9]/g.test(PID)) {
              return true;
            } else if (this.studyData.participantIdFormatConfigured.isDisallowSpecialCharacters && /[[\\\];=!@#$%^&*(),'_.?":{}|<>+~/`-]/g.test(PID)) {
              return true;
            }
          }
        } else {
          return true;
        }
      }
      return false;
    },
    toggleScheduleModal(value) {
      this.isScheduleStartModalShown = value;
      this.modalStatus = false;
    },
    getScreenFailureReasons(data) {
      this.failureReasons = [];
      this.failureReasons = data.screenFailureReasons;
      this.selectedStatus = "Screen Failure";
    },
    getDiscontinuedReasons(data) {
      this.failureReasons = [];
      this.selectedReason = "Discontinued";
      this.failureReasons.reasons = data.discontinuationReason.split(",").map(function(item) {
        return item.trim();
      });
      const i = this.failureReasons.reasons.indexOf("Other");
      if (i > -1) {
        this.failureReasons.reasons.splice(i, 1);
      }
      if (data.statusChangeReason != "") {
        this.failureReasons.other = data.statusChangeReason;
      }
    },
    closeScreenFailureModal() {
      window.$("#screenFailureResons").modal("hide");
    },
    checkLegacyValue() {
      this.$api.getLegacyData(this.studyId).then(response => {
        if (response) {
          this.legacyVal = response.body;
        }
      });
    }
  },
  mounted() {
    this.getAllParticipants(this.selectedShowOption, this.currentPage);
    this.getStudyDetails();
    this.getCustomLabels();
    this.getNotInvitedUserList(false);
    this.getToggledFeatures();
    this.getStudyDetailsFact();
    this.checkLegacyValue();

    //verify that the user has come to this page from compose message and the compose id exists in local storage
    if (this.composeMessageId) {
      const comMsgObj = LocalStorageService.getItem(this.composeMessageId);
      if (comMsgObj === null || comMsgObj === undefined) {
        this.composeMessageId = null;
        this.$toastr.error("Something went wrong, please start from the compose process again.");
        this.$router.push({
          name: "study-participant-messages"
        });
      } else {
        //comMsgObj = JSON.parse(comMsgObj);
        if (Object.keys(comMsgObj).length != 0) {
          this.composeParticipants = comMsgObj.participantList;
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
// Style for quick fixes bootstrap after migration (before redesign should be removed)

body {
  color: #333;
  .mb-5 {
    margin-bottom: 5px !important;
  }
}
.question-answer-style-heading {
  height: 13px;
  font-family: RobotoRegular;
  font-size: 11px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4a4a4a;
}
.question-answer-style {
  font-family: RobotoRegular;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4a4a4a;
}
.link {
  color: #1e8fe1 !important;
  cursor: pointer;
}
.link:hover {
  color: #1e8fe1;
  text-decoration-line: underline !important;
}
.h2,
h2 {
  font-size: 30px;
  margin: 20px 0 10px;
}

.h3,
h3 {
  font-size: 24px;
  color: #333;
}

.h4,
h4 {
  font-size: 18px;
  margin: 0;
}

.btn {
  font-size: 14px;
}

.row {
  display: block;

  &:after {
    content: "";
    clear: both;
    display: block;
  }
}
.modal-content-style {
  padding: 15px;
  width: 477px;
  height: 207px;
  border-radius: 3px;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.2);
  background-color: #ffffff;
}
.gray-color {
  color: #4a4a4a !important;
}
.purple_color {
  color: #a569bd !important;
}
.invite-que-style {
  font-family: RobotoRegular;
  font-size: 14px;
  color: #666669;
}
.change-screening-status {
  margin: 5px 15px;
  width: auto;
  height: 32px;
  font-family: RobotoRegular;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.78;
  letter-spacing: normal;
  color: #666669;
}
.participant-ID {
  margin: 6px 0px 6px 0px;
  width: 76px;
  font-family: RobotoRegular;
  font-size: 12px;
  font-weight: bold;
  color: #b0bac9;
}
.participant-ID-field {
  margin: 6px 0px 6px 0px;
  width: 78px;
  height: 9px;
  font-family: RobotoRegular;
  font-size: 14px;
  color: #4a4a4a;
}
.thread-ID {
  margin: 6px 0px 6px 0px;
  width: 65px;
  font-family: RobotoRegular;
  font-size: 12px;
  font-weight: bold;
  color: #b0bac9;
}
.thread-ID-field {
  margin: 6px 0px 6px 0px;
  font-family: RobotoRegular;
  font-size: 14px;
  color: #4a4a4a;
}

.cancel-modal-but {
  border: 1px solid #e0e0e0;
  border-radius: 18px;
  width: 110px;
  height: 36px;
  background-color: #e0e0e0;
}
.cancel-modal-span {
  width: 78px;
  height: 20px;
  font-family: RobotoRegular;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: #000000;
}
.screening-failed-but {
  border: 1px solid #f16559;
  border-radius: 18px;
  width: 148px;
  height: 36px;
  background-color: #f16559;
}
.screening-failed-span {
  width: 116px;
  height: 20px;
  font-family: RobotoRegular;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: #ffffff;
}
.screening-passed-but {
  border: 1px solid #4c8ce4;
  border-radius: 18px;
  width: 147px;
  height: 36px;
  background-color: #4c8ce4;
}
.screening-passed-span {
  width: 115px;
  height: 20px;
  font-family: RobotoRegular;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: #ffffff;
}
.rectangle {
  display: flex;
  width: auto;
  min-height: 59px;
  background-color: #eaf0f4;
}
.header-rectangle {
  width: 100%;
  height: 44px;
  background-color: #f1f4f8;
}
.eligibility-heading-style {
  width: 100%;
  font-family: RobotoRegular;
  font-size: 16px;
  color: #000000;
  text-align: center;
  padding: 16px;
  border-bottom: 5px solid #f1f4f8;
}
.agreement-accepted-style {
  width: 90%;
  height: 16px;
  font-family: RobotoRegular;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4a4a4a;
  text-align: end;
}
.eligibility-popup-icon {
  margin-left: 6px;
  margin-bottom: 6px;
  width: 19px;
  height: 19px;
  object-fit: contain;
}
.lang-slection-style {
  margin: 6px;
  font-family: RobotoRegular;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  color: #4a4a4a;
  background-color: #f1f4f8;
  border: none;
  outline: 0;
}
.lang-slection-style :focus {
  border: none;
  outline: 0;
}
.close-btn {
  width: 28px;
  font-size: 18px;
  line-height: 1;
  color: #4a4a4a;
  font-weight: normal;
  border: 0;
  margin: 10px;
  background-color: #f1f4f8;
}

.loading-style {
  font-family: RobotoRegular;
  font-size: 25px;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4a4a4a;
  left: 20;
  width: 70px;
  height: 25px;
  position: absolute;
  left: 48%;
  top: 50%;
}
.question-wrapper::-webkit-scrollbar {
  width: 6px; /* width of the entire scrollbar */
}
.question-wrapper::-webkit-scrollbar-track {
  background: transparent; /* color of the tracking area */
}
.question-wrapper::-webkit-scrollbar-thumb {
  background-color: #e6e9ed; /* color of the scroll thumb */
  border-radius: 20px; /* roundness of the scroll thumb */
  border: 3px solid transparent; /* creates padding around scroll thumb */
}
.question-wrapper {
  overflow-y: scroll;
  height: 485px;
  font-family: RobotoRegular;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4a4a4a;
  scrollbar-width: thin; /* "auto" or "thin"  */
  scrollbar-color: #e6e9ed transparent; /* scroll thumb & track */
}
.field-wrapper {
  width: auto;
  padding: 5px 10px;
}
.check-withwrawn {
  vertical-align: middle;
  width: 16.7px;
  height: 16.7px;
}
.margin-style-1 {
  margin: 10px 30px 10px 40px !important;
  border-bottom: 1px solid #e5e5e5;
}
.margin-style-2 {
  margin: 10px 44px 10px 40px !important;
  border-bottom: 1px solid #e5e5e5;
}

.Show-Withdrawn-or-Failed-participants {
  margin-top: 11px;
  margin-bottom: 0;
  height: 14px;
  font-family: RobotoRegular;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.17;
  letter-spacing: normal;
  color: #000000;
  margin-left: 25px;
}

.search-field {
  padding: 8px !important;
  background-image: url("/static/img/search1.svg");
  background-repeat: no-repeat;
  background-position: 97% 50%;
  color: #2d3752;
  // border: 1px solid #e4e8eb !important;
  border-radius: 4px;
  border: solid 1px #b0bac9 !important;
  background-color: #ffffff;
}

.select_section {
  select.form-control {
    height: 40px !important;
    line-height: 22px;
  }
}

.show_section {
  select.form-control {
    height: 36px !important;
    line-height: 22px;
  }
}

.modal-dialog {
  min-width: 31%;
}

.trigger-day-btn {
  border-radius: 100px;
  &.cancel {
    background-color: #000;
    color: #fff;
  }
}

// END of style for quick fixes bootstrap after migration (before redesign should be removed)

.main-content {
  width: 100%;
}

.add-invite-btn {
  color: #fff !important;
  background-color: #1e8fe1 !important;
  border-color: #1e8fe1 !important;
}

.yes-btn {
  color: #fff !important;
  background-color: #1e8fe1 !important;
  border-color: #1e8fe1 !important;
  width: 100px !important;
}

.no-btn {
  color: #fff !important;
  background-color: #4a4a4a !important;
  border-color: #4a4a4a !important;
  width: 100px !important;
}
.cancel-btn {
  color: #fff !important;
  background-color: #4a4a4a !important;
  border-color: #4a4a4a !important;
}

.error-style {
  font-size: 12px;
  color: #ff4848;
  padding-bottom: 5px;
  padding-left: 0;
}
.invite-text {
  color: #666669 !important;
}
.send-invite {
  background-color: #f16559;
  color: #fff;
  font-size: 12px;
}
.ml-30 {
  margin-left: 30px;
}
.newBtn {
  height: 36px;
  color: #fff !important;
  background-color: #1e8fe1 !important;
  border-color: #1e8fe1 !important;
  /*cursor: pointer;*/
  font-weight: 400;
  padding: 0.375rem 15px;
}

.color_1e8fe1 {
  color: #1e8fe1;
}

.color_f16559 {
  color: #f16559;
}

.importBtn {
  // width: 85px;
  height: 30px;
  border-radius: 4px;
  border: solid 1px #1e8fe1;
  background-color: #ffffff;
  color: #1e8fe1;
  cursor: pointer;
  font-size: 14px;
}

.img-mr {
  margin-top: -2px;
}

.width-650 {
  width: 650px !important;
  min-width: 650px !important;
}

.width-1100 {
  width: 1100px !important;
  min-width: 1100px !important;
}
.width-850 {
  width: 850px !important;
  min-width: 850px !important;
}

.width-700 {
  width: 700px !important;
  min-width: 700px !important;
}
.width-100 {
  width: 100px;
}

.height-250 {
  height: 250px;
}

.height-auto {
  height: auto !important;
}

.participant-bg {
  background: #f5f8fa !important;
  // height: 100%;
  // min-height: 100vh;
  color: #34537d;
  overflow: auto;

  h3 {
    color: #34537d;
  }
}

.table-striped > tbody > tr:nth-of-type(odd) {
  background-color: #f5f8fa !important;
}

.table {
  .heading-color {
    color: #9b9b9b !important;
    border-top: none;
    border-bottom: none;
    vertical-align: top;
  }

  th,
  td {
    padding: 10px;
    line-height: 30px;
    word-break: break-all;
  }
}
.table-border {
  border-bottom: 1px solid #e4e8eb !important;
}
.new-label-width {
  min-width: 300px !important;
}

.invite-width {
  min-width: 250px !important;
}

.table-content-color {
  color: #4a4a4a;
  height: 55px !important;
}
.azure-class {
  color: #1f95f2;
}
.modal-content {
  padding: 15px;
}
.table-column {
  width: 100%;
  background-color: #fff;
  height: 100%;
  padding: 18px 0px 0px 0px;
  color: #9b9b9b;
  border-radius: 4px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.06);
}
.color_import {
  color: #34537d;
  padding-bottom: 30px;
}
.input-bg {
  background: #ffffff !important;
  color: #4a4a4a !important;
  border: 1px solid #e4e8eb !important;
}

.icon-bg {
  color: #ffffff;
}

.icon-color {
  color: #34537d;
}

.fs-14 {
  font-size: 14px !important;
}

.view-color {
  color: #00b1ff;
  cursor: pointer;
}
.close-style {
  position: relative;
  right: 8px;
  top: 5px;
  font-size: 28px;
}
.footer-close-style {
  color: #34537d;
  margin-bottom: 15px;
  text-align: center;
  cursor: pointer;
}

.lh-15 {
  line-height: 15px;
}

.download-style {
  color: #00baf9;
  text-align: center;
  font-size: 16px;
  padding-bottom: 20px;
}
.file-style {
  color: #2ecc71;
  text-align: center;
  font-size: 16px;
  padding-bottom: 20px;
}
.modal-title {
  color: #34537d;
  padding: 10px 0;
  font-size: 24px;
}
.number-color {
  color: #ffa5a8 !important;
}
.modal-style {
  padding: 0;
  font-size: 16px;
  padding-bottom: 30px;
}
.modal-w-h-style {
  width: 700px;
  height: 673px;
  border-radius: 2px;
  background-color: #ffffff;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -75% !important;
  margin-top: -60% !important;
}
.modal-info {
  color: #535456;
}

.color_2d3752 {
  color: #2d3752;
}

.color_4a4a4a {
  color: #4a4a4a;
}

.color_e74c3c {
  color: #e74c3c;
}

.bb-e4e8eb {
  border-bottom: 1px solid #e4e8eb;
}

.download-modal {
  padding-left: 20px !important;
  padding-right: 20px !important;
}

.link-color {
  color: #1d7fee !important;
}

.participant_content modal-dialog {
  width: 500px;
}
.file-upload-participant {
  border: none;
  border-radius: 30px;
  height: 100%;
  background-color: #34537d !important;
  margin-bottom: 10px;
  display: block;
  width: 100% !important;
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}

.select_control {
  background-repeat: no-repeat;
  border: none;
}

.label-icon {
  border-radius: 3px;
  font-size: 16px;
  background-color: #e2e8ee;
  padding: 2px 6px;
}

.table .trigger:hover {
  background-color: #e2e8ee;
  border-radius: 3px;
  .edit {
    display: inline;
    top: 8px;
    left: 15px;
  }
}

.table .trigger2:hover {
  background-color: #e2e8ee;
  border-radius: 3px;
  .edit {
    display: inline;
    top: 8px;
    left: 4px;
  }
}

.pb-90 {
  padding-bottom: 90px !important;
}

.edit {
  padding: 0px;
  display: none;
  font-size: 16px;
  cursor: pointer;
}

.first {
  position: absolute;
  width: 200px;
  left: 0;
  line-height: 20px !important;
  padding: 10px !important;
  max-width: 200px !important;
}

.wrapper {
  overflow-x: auto;
}

@media (max-width: 575px) {
  .xs-none {
    display: none;
  }
  .xs-pl-0 {
    padding-left: 0px;
  }
  .mob-pt15 {
    padding-top: 15px;
  }
}
@media (max-width: 1024px) {
  .modal-w-h-style {
    margin-left: -100% !important;
    margin-top: -85% !important;
  }
}
@media (max-width: 1199px) {
  .has-sidemenu .container {
    padding-left: 30px !important;
    padding-right: 30px !important;
    width: auto;
    max-width: inherit;
  }
}

@media (min-width: 200px) and (max-width: 299px) {
  .ellipsis {
    width: 98px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .ellipsisPID {
    width: 50px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
@media (min-width: 300px) and (max-width: 350px) {
  .ellipsis {
    width: 138px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .ellipsisPID {
    width: 95px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

@media (min-width: 351px) and (max-width: 410px) {
  .ellipsis {
    width: 175px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .ellipsisPID {
    width: 120px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

@media (min-width: 411px) and (max-width: 539px) {
  .ellipsis {
    width: 220px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .ellipsisPID {
    width: 175px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
@media (min-width: 540px) and (max-width: 767px) {
  .ellipsis {
    width: 340px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .ellipsisPID {
    width: 260px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .ellipsis {
    width: 340px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .ellipsisPID {
    width: 340px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.modal-header,
.modal-title {
  padding: 0 !important;
}

.select_section:after {
  content: "\F107";
  font: normal normal normal 20px/1 FontAwesome;
  color: #1f8fe1;
  right: 25px;
  top: 10px;
  height: 34px;
  padding: 0px 0px 0px 1px;
  /* border-left: 1px solid #0ebeff; */
  position: absolute;
  pointer-events: none;
}

.show_section:after {
  content: "\F107";
  font: normal normal normal 20px/1 FontAwesome;
  color: #1e8fe1;
  right: 10px;
  top: 10px;
  height: 34px;
  padding: 0px 0px 0px 1px;
  position: absolute;
  pointer-events: none;
}

.show_section.siteId:after,
.show_section.country:after,
.show_section.langugage:after {
  content: "\F107";
  font: normal normal normal 20px/1 FontAwesome;
  right: 25px;
  top: 8px;
  position: absolute;
}

.lh-36 {
  line-height: 36px;
}

.width-80 {
  width: 80px !important;
}

.height-500 {
  min-height: 600px !important;
}

.sortDown {
  position: absolute;
  padding-left: 4px;
  padding-top: 3px;
}

.sortUp {
  position: absolute;
  margin-top: -3px;
  padding-left: 4px;
}

.position-relative {
  position: relative;
}

.dropdown-toggle::after {
  display: none;
}

.line-height {
  line-height: 1.5;
}

.pt-150 {
  padding-top: 150px;
}

.arrow-icon {
  width: 32px;
  height: 32px;
  border-radius: 3px;
  background-color: #ffffff;
  border: solid 1px #e4e8eb;
  text-align: center;
  font-size: 23px;
  line-height: 10px !important;
  color: #e4e8eb;
}

.pagination {
  width: 32px;
  height: 32px;
  border-radius: 3px;
  background-color: #ffffff;
  border: solid 1px #e4e8eb;
  text-align: center;
  font-size: 13px;
  line-height: 23px !important;
  color: #4a4a4a;
  padding-left: 11px !important;
}

.pagination2 {
  width: 40px;
  height: 32px;
  background-color: #ffffff;
  font-size: 13px;
  line-height: 23px !important;
  color: #4a4a4a;
  padding-left: 6px !important;
}

.disabledPagination {
  pointer-events: none;
}

.display-inline-flex {
  display: inline-flex !important;
}

.position-absolute {
  position: absolute;
}

.position-relative {
  position: relative;
}

.bottom-0 {
  bottom: 0px;
}

#download-report-modal.modal.show {
  overflow-x: hidden;
  overflow-y: auto;
}
body.modal-open {
  overflow: hidden;
}

/* Hide the browser's default checkbox */
.Show-Withdrawn-or-Failed-participants input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.Show-Withdrawn-or-Failed-participants .checkmark {
  position: absolute;
  top: 10px;
  left: 0;
  height: 16px;
  width: 16px;
  background-color: #fff;
  border: 1px solid #dedede;
  border-radius: 3px;
}

/* On mouse-over, add a grey background color */
.Show-Withdrawn-or-Failed-participants:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.Show-Withdrawn-or-Failed-participants input:checked ~ .checkmark {
  background-color: #2196f3;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.Show-Withdrawn-or-Failed-participants input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.Show-Withdrawn-or-Failed-participants .checkmark:after {
  left: 6px;
  top: 2px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.select-participant {
  /*checkbox data*/
  input[type="checkbox"] + span {
    display: block;
  }

  input[type="checkbox"] {
    display: none;
    height: 16px;
    width: 16px;
  }
  input[type="checkbox"] + span:before {
    content: "\f00c";
    border: 0.1em solid #d3dfe4;
    border-radius: 3px;
    width: 16px;
    height: 16px;
    padding: 3px 3px;
    vertical-align: middle;
    color: transparent;
    background-color: #fff;
    font-size: 10px;
    font: normal normal normal 10px/1 FontAwesome;
  }

  input[type="checkbox"]:checked + span:before {
    background-color: #4c8ce4;
    border: 0.1em solid #4c8ce4;
    color: #fff;
    font-size: 10px;
  }
}
.back-to-compose {
  button {
    font-weight: normal;
    width: auto;
    height: auto;
    padding: 7px 27px;
  }
}

.compose-part-sel-text {
  color: #979797;
  font-size: 14px;
  font-family: RobotoRegular;
  margin-left: 35px;
  font-weight: normal;
}

.participant-breadcrumb {
  height: auto;
  width: auto;
  background-color: transparent;
  .breadcrumb {
    padding: 17px 30px;
    padding-bottom: 9px;
    background-color: transparent;
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 0;
    list-style: none;
    border-radius: 0.25rem;

    .breadcrumb-item {
      color: #4a4a4a;
      a {
        color: #4c8ce4;
      }
      &.current-label {
        color: #9b9b9b;
        cursor: text;
      }
    }
  }
}

.activeModificationBlock {
  width: 120px;
  height: 10px;
  background-color: #cccccc;
  padding-left: 4px;
  padding-right: 4px;
  border-radius: 2px;
}
.modifiedText {
  color: #ffffff;
  opacity: 0.7;
  font-size: 11px;
}
.information {
  background-color: #eaf0f4;
  .modal-heading {
    font-weight: 600;
  }
}
.draft-lang {
  display: none;
}
.card-horizontal {
  display: flex;
  flex: 1 1 auto;
}
.card {
  border-radius: 4px;
  border: solid 1px #b0bac9;
  background-color: #ffffff;
  margin: 8px 0px;
  height: auto;
}
.img-square-wrapper {
  padding: 0 20px;
  position: relative;
  width: 50px;
  border-radius: 4px;
  border: solid 1px #b0bac9;
  background-color: #b0bac9;
  height: auto;
  margin-right: -1px;
}
.card-img {
  font-weight: bolder;
  transform: rotate(-45deg);
  color: #ffffff;
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-10%, -50%);
}
.d_margin {
  margin: 50% 5%;
}
.content {
  width: 100%;
  padding: 20px;
}
.participant_id {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #4a4a4a;
}
.card-body {
  padding: 10px !important;
}
.status {
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #4a4a4a;
}
.cutom_class {
  display: flex !important;
  margin-bottom: 10px !important;
  width: auto !important;
}
.card_wrapper {
  max-height: 535px;
  overflow: scroll;
}
.ta-e {
  text-align: end !important;
}
@media (min-width: 768px) and (max-width: 991px) {
  .width-850 {
    width: 750px !important;
    min-width: 750px !important;
  }
  .width-1100 {
    width: 750px !important;
    min-width: 750px !important;
  }
}

//screen failure modal design
.screen-failure-popup-icon {
  width: 16px;
  object-fit: contain;
}
.screen-failure {
  height: auto;
  width: auto;
  margin: 9px 13px 6px 0;
  // padding: 10px 96px 51px 16px;
  border-radius: 4px;
  border: solid 1px #b0bac9;
}
.failure-reasons {
  font-family: Roboto-Regular;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  text-align: left;
  color: #000;
  line-height: 2.14;
}
.other-failure-reasons {
  font-family: Roboto-Regular;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  text-align: left;
  color: #666669;
  line-height: 1.5;
  margin: 0px;
  padding-bottom: 5px;
  white-space: pre-wrap;
}
.failure-reasons ul {
  margin: 0px;
  padding: 10px 32px 10px 32px;
}
.reasons-modal-title {
  font-weight: bold;
  width: auto;
  height: 19px;
  margin: 8px 239px 9px 0;
  font-family: Roboto-Regular;
  font-size: 16px;
  text-align: left;
  color: #000;
}

@media (min-width: 992px) and (max-width: 1111px) {
  .width-850 {
    width: 750px !important;
    min-width: 750px !important;
  }
  .width-1100 {
    width: 800px !important;
    min-width: 800px !important;
  }
}
</style>
<style scoped lang="scss" src="@/assets/otp-input.scss"></style>
